(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6731,3845],{

/***/ 36630:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "M": function() { return /* binding */ apolloClientQuery; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(47568);
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(97582);



var apolloClientQuery = function() {
    var _ref = (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(function(client, query, variables) {
        var ref, queryResponse, err;
        return (0,_swc_helpers_src_ts_generator_mjs__WEBPACK_IMPORTED_MODULE_1__.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    _state.trys.push([
                        0,
                        2,
                        ,
                        3
                    ]);
                    return [
                        4,
                        client.query({
                            query: query,
                            variables: (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({}, variables),
                            errorPolicy: "all"
                        })
                    ];
                case 1:
                    queryResponse = _state.sent();
                    if (queryResponse.errors && ((ref = queryResponse.errors) === null || ref === void 0 ? void 0 : ref.length) > 0) {
                        throw new Error(queryResponse.errors[0].message);
                    }
                    return [
                        2,
                        {
                            queryResponse: queryResponse,
                            error: null
                        }
                    ];
                case 2:
                    err = _state.sent();
                    return [
                        2,
                        {
                            queryResponse: null,
                            error: err
                        }
                    ];
                case 3:
                    return [
                        2
                    ];
            }
        });
    });
    return function apolloClientQuery(client, query, variables) {
        return _ref.apply(this, arguments);
    };
}();



/***/ }),

/***/ 22284:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(12963);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15861);


var Breadcrumbs = function(param) {
    var breadcrumbs = param.breadcrumbs;
    var schemaJson = {
        "@context": "http://schema.org",
        "@type": "BreadcrumbList",
        itemListElement: []
    };
    var formatJSON = function(breadcrumb, index) {
        return {
            "@type": "ListItem",
            position: index + 1,
            item: {
                "@id": "".concat(breadcrumb.url),
                name: "".concat(breadcrumb.content)
            }
        };
    };
    var createBreadcrumbSchema = function() {
        schemaJson.itemListElement = breadcrumbs.map(function(breadcrumb, index) {
            return formatJSON(breadcrumb, index);
        }) || [];
        return schemaJson;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                children: breadcrumbs.map(function(param, index) {
                    var content = param.content, url = param.url;
                    return index + 1 !== breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        component: "a",
                        href: url,
                        variant: "body2",
                        children: content
                    }, content) || index + 1 === breadcrumbs.length && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        role: "heading",
                        variant: "body2",
                        children: content
                    }, content);
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                "data-testid": "breadcrumbListSchema",
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createBreadcrumbSchema())
                }
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Breadcrumbs);


/***/ }),

/***/ 96301:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11752);
/* harmony import */ var next_config__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_config__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(9008);
/* harmony import */ var next_head__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_head__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(79967);
/* harmony import */ var _contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(73739);





var ref = next_config__WEBPACK_IMPORTED_MODULE_1___default()(), NEXT_PUBLIC_APP_URL = ref.publicRuntimeConfig.NEXT_PUBLIC_APP_URL;
var PageMeta = function(param) {
    var hrefLangLinks = param.hrefLangLinks, title = param.title, canonicalUrl = param.canonicalUrl, metaDescriptions = param.metaDescriptions, metaKeywords = param.metaKeywords, _paginationPageCount = param.paginationPageCount, paginationPageCount = _paginationPageCount === void 0 ? 1 : _paginationPageCount, _paginationCurrentPage = param.paginationCurrentPage, paginationCurrentPage = _paginationCurrentPage === void 0 ? 1 : _paginationCurrentPage, isCostGuidePage = param.isCostGuidePage, seoSegmentNamePlural = param.seoSegmentNamePlural, isCampsAndActivitiesPage = param.isCampsAndActivitiesPage;
    var ref = (0,_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_4__/* .usePageAttributes */ .l)(), segmentNamePlural = ref.segmentNamePlural, pageType = ref.pageType, city = ref.city, state = ref.state;
    var logoPath = "".concat(NEXT_PUBLIC_APP_URL, "/img/care-no-tag.jpg?v=2");
    var prevLink;
    var nextLink;
    var canonicalPageUrl;
    var newTitle;
    var noindexPage = pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL && paginationCurrentPage > 1 || isCampsAndActivitiesPage && paginationCurrentPage > 1;
    if (paginationCurrentPage > 1) {
        if (pageType === _generated_globalTypes__WEBPACK_IMPORTED_MODULE_3__/* .SEOSegmentationPageType.LOCAL */ .a6.LOCAL) {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(segmentNamePlural, " in ").concat(city, ", ").concat(state);
        } else {
            newTitle = "Page ".concat(paginationCurrentPage, " - Top ").concat(seoSegmentNamePlural !== null && seoSegmentNamePlural !== void 0 ? seoSegmentNamePlural : segmentNamePlural);
        }
        canonicalPageUrl = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage);
        if (paginationCurrentPage < paginationPageCount) {
            nextLink = "".concat(canonicalUrl, "-page").concat(paginationCurrentPage + 1);
            prevLink = paginationCurrentPage === 2 ? canonicalUrl : "".concat(canonicalUrl, "-page").concat(paginationCurrentPage - 1);
        } else {
            prevLink = "".concat(canonicalUrl);
        }
    } else if (paginationCurrentPage === 1) {
        newTitle = title;
        canonicalPageUrl = canonicalUrl;
        if (paginationPageCount > 1) {
            nextLink = "".concat(canonicalUrl, "-page2");
        }
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)((next_head__WEBPACK_IMPORTED_MODULE_2___default()), {
        children: [
            hrefLangLinks && hrefLangLinks.map(function(param) {
                var languageCode = param.languageCode, countryCode = param.countryCode, url = param.url;
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                    rel: "alternate",
                    href: url,
                    hrefLang: "".concat(languageCode, "-").concat(countryCode)
                }, url);
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("title", {
                children: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                charSet: "utf-8"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                httpEquiv: "X-UA-Compatible",
                content: "IE=edge,chrome=1"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "description",
                content: metaDescriptions
            }),
            metaKeywords && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "keywords",
                content: metaKeywords
            }),
            noindexPage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "robots",
                content: "noindex, follow"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "canonical",
                href: canonicalPageUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "viewport",
                content: "width=device-width, initial-scale=1.0"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                name: "verify-v1",
                content: "zz15lR180u9eCqTfur/9l+bMP75AampYtDEm6OnbkWY="
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:title",
                content: newTitle
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:type",
                content: "website"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:image",
                content: logoPath
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:url",
                content: canonicalUrl
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:description",
                content: metaDescriptions
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "og:site_name",
                content: "Care.com"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "image/jpeg",
                property: "og:image:type"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:width"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                content: "1080",
                property: "og:image:height"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("meta", {
                property: "fb:page_id",
                content: "6030284861"
            }),
            isCostGuidePage && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "shortcut icon",
                href: "https://www.care.com/img/crcm-favicon.ico"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify({
                        "@context": "https://schema.org",
                        "@type": "Organization",
                        logo: logoPath,
                        name: "Care.com",
                        sameAs: [
                            "https://www.facebook.com/caredotcom/",
                            "https://twitter.com/CareDotCom",
                            "https://www.instagram.com/careorg/",
                            "https://www.linkedin.com/company/care-com", 
                        ],
                        url: "https://www.care.com"
                    })
                }
            }),
            !isCostGuidePage && nextLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "next",
                href: nextLink
            }),
            !isCostGuidePage && prevLink && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("link", {
                rel: "prev",
                href: prevLink
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (PageMeta);


/***/ }),

/***/ 6551:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26042);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70872);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(6964);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_1__);




var OffsetPagination = function(param) {
    var pagination = param.pagination, onPageClick = param.onPageClick, segmentId = param.segmentId, pageSelected = param.pageSelected;
    var hasPages = pagination.numberOfPages > 1;
    var hasResults = pagination.numberOfPages > 0;
    var isFirstPage = pageSelected === 1;
    var isLastPage = pageSelected === pagination.numberOfPages;
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_1__.useRouter)();
    var handleChangePage = function(event, newPage) {
        event.preventDefault();
        onPageClick(newPage);
        // only show "page" for pages > 1; "/senior-care-page1" should just be "/senior-care"
        var url = newPage === 1 ? segmentId : "".concat(segmentId, "-page").concat(newPage.toString());
        router.push(url, undefined, {
            shallow: true
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        children: [
            hasPages && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                mt: 3,
                mb: 2.25,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    count: pagination.numberOfPages,
                    onChange: handleChangePage,
                    page: pageSelected,
                    renderItem: function(item) {
                        var isNextButton = item.type === "next";
                        var isPrevButton = item.type === "previous";
                        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                            component: isNextButton && isLastPage || isPrevButton && isFirstPage ? "div" : "a",
                            href: isNextButton && isLastPage || isPrevButton && isFirstPage ? undefined : "".concat(segmentId).concat(item.page === 1 || item.page === 0 ? "" : "-page".concat(item.page)),
                            role: "button"
                        }, item));
                    },
                    sx: {
                        "& .MuiPaginationItem-page": {
                            minWidth: "24px",
                            height: "24px"
                        }
                    }
                })
            }),
            hasResults && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                role: "heading",
                variant: "body3",
                color: "primary",
                mt: !hasPages ? 3 : undefined,
                mb: 3,
                children: [
                    "Showing ",
                    pagination.startIndex + 1,
                    " - ",
                    pagination.endIndex,
                    " of",
                    " ",
                    pagination.totalNumberOfResults
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (OffsetPagination);


/***/ }),

/***/ 34435:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "T": function() { return /* binding */ ArticleCard; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(86492);
/* harmony import */ var he__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(he__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(23795);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(15861);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(91036);
/* harmony import */ var sanitize_html__WEBPACK_IMPORTED_MODULE_10___default = /*#__PURE__*/__webpack_require__.n(sanitize_html__WEBPACK_IMPORTED_MODULE_10__);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19147);
/* harmony import */ var _utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(42182);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);









var ArticleCard = function(param) {
    var imageUrl = param.imageUrl, title = param.title, url = param.url, description = param.description, articleCreateDate = param.articleCreateDate, _slotProps = param.slotProps, slotProps = _slotProps === void 0 ? {} : _slotProps;
    var ref = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_3__/* .useResponsive */ .F)(), isSmallViewport = ref.isSmallViewport, isLargeViewport = ref.isLargeViewport;
    // remove the <p> tag from the description
    var previewDescription = description ? "".concat(description.replace(/<\/?p>/gi, ""), "...") : null;
    var articleDate = articleCreateDate !== null ? (0,_utils_dateMonthYearFormat__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)({
        dateTime: articleCreateDate,
        useOrdinalDay: false,
        useLongMonth: true,
        useFullDate: true
    }) : null;
    var amplitudeEventCardClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Clicked Article Carousel"
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.link), {
            onClick: amplitudeEventCardClick,
            href: url,
            target: !isSmallViewport ? "_blank" : "_self",
            variant: "link2",
            sx: function(theme) {
                return {
                    color: theme.palette.text.primary,
                    textDecoration: "none",
                    WebkitTapHighlightColor: "transparent",
                    "&:hover": {
                        cursor: "pointer",
                        textDecoration: "none"
                    }
                };
            },
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.image), {
                    mb: {
                        xs: 1,
                        sm: 2
                    },
                    borderRadius: "24px",
                    component: "img",
                    src: imageUrl,
                    alt: title,
                    loading: "lazy"
                })),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                    display: "flex",
                    flexDirection: "column",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.title), {
                            component: "h3",
                            variant: "h3",
                            mb: 1,
                            children: he__WEBPACK_IMPORTED_MODULE_1___default().decode(title)
                        })),
                        previewDescription && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)({}, slotProps === null || slotProps === void 0 ? void 0 : slotProps.description), {
                            component: "p",
                            variant: isLargeViewport ? "body2" : "body3",
                            color: "text.secondary",
                            dangerouslySetInnerHTML: {
                                __html: sanitize_html__WEBPACK_IMPORTED_MODULE_10___default()(he__WEBPACK_IMPORTED_MODULE_1___default().decode(articleDate ? "".concat(articleDate, " - ").concat(previewDescription) : previewDescription))
                            }
                        }))
                    ]
                })
            ]
        }))
    });
};


/***/ }),

/***/ 83845:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "ArticleSection": function() { return /* binding */ ArticleSection; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(46574);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(15861);
/* harmony import */ var _components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(73739);
/* harmony import */ var _components_common_Carousel__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(35129);
/* harmony import */ var _components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(19147);
/* harmony import */ var _components_common_ArticleSection_ArticleCard__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34435);






var ArticleSection = function(param) {
    var articles = param.articles;
    var isSmallViewport = (0,_components_hooks_useResponsive__WEBPACK_IMPORTED_MODULE_4__/* .useResponsive */ .F)().isSmallViewport;
    var segmentNameSingular = (0,_components_contexts_PageAttributesContext__WEBPACK_IMPORTED_MODULE_1__/* .usePageAttributes */ .l)().segmentNameSingular;
    if (articles.length <= 0) {
        return null;
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        maxWidth: "lg",
        sx: {
            pt: {
                xs: 4,
                sm: 0
            },
            mb: {
                xs: 6,
                md: 12
            },
            mt: {
                sm: 6,
                md: 12
            },
            position: "relative",
            px: {
                xl: 0
            }
        },
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                component: "h2",
                variant: isSmallViewport ? "h1" : "display3",
                mb: {
                    xs: 4,
                    sm: 6
                },
                mt: 0,
                children: segmentNameSingular ? "".concat(segmentNameSingular, " Articles") : "Related articles"
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_Carousel__WEBPACK_IMPORTED_MODULE_2__/* .Carousel */ .l, {
                controlVariant: isSmallViewport ? "none" : "topRight",
                showProgressIndicator: isSmallViewport,
                itemsPerView: isSmallViewport ? 1 : 3,
                children: articles.map(function(article) {
                    var ref;
                    if (!((ref = article.largeImage) === null || ref === void 0 ? void 0 : ref.imageUrl)) return null;
                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_common_ArticleSection_ArticleCard__WEBPACK_IMPORTED_MODULE_3__/* .ArticleCard */ .T, {
                        url: article.url,
                        imageUrl: article.largeImage.imageUrl,
                        title: article.title,
                        description: article.description,
                        articleCreateDate: article.createDate
                    }, article.title);
                })
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["default"] = (ArticleSection);


/***/ }),

/***/ 35129:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "l": function() { return /* binding */ Carousel; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(69396);
/* harmony import */ var _swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(29815);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(46237);
/* harmony import */ var _care_react_component_lib__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(87688);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(19957);
/* harmony import */ var _care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(98820);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(2734);
/* harmony import */ var _mui_material__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(80822);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(96373);
/* harmony import */ var _care_react_icons__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(54743);
/* harmony import */ var _lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(883);










var Carousel = function(param) {
    var children = param.children, _controlVariant = param.controlVariant, controlVariant = _controlVariant === void 0 ? "none" : _controlVariant, _showProgressIndicator = param.showProgressIndicator, showProgressIndicator = _showProgressIndicator === void 0 ? false : _showProgressIndicator, _itemGap = param.itemGap, itemGap = _itemGap === void 0 ? 3 : _itemGap, _itemsPerView = param.itemsPerView, itemsPerView = _itemsPerView === void 0 ? 3 : _itemsPerView, slotProps = param.slotProps;
    var theme = (0,_mui_material__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)();
    var originalSlides = react__WEBPACK_IMPORTED_MODULE_1__.Children.toArray(children);
    var totalSteps = originalSlides.length;
    var slides = (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides).concat((0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides), (0,_swc_helpers_src_to_consumable_array_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(originalSlides));
    var gapInPixels = parseInt(theme.spacing(itemGap), 10);
    var ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(totalSteps), currentSlide = ref[0], setCurrentSlide = ref[1];
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isTransitioning = ref1[0], setIsTransitioning = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(0), slideOffset = ref2[0], setSlideOffset = ref2[1];
    var touchStartX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var touchEndX = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(0);
    var containerRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!containerRef.current) return undefined;
        var resizeObserver = new ResizeObserver(function(entries) {
            var ref;
            var containerWidth = entries[0].contentRect.width;
            var itemWidth = (containerWidth - (itemsPerView - 1) * gapInPixels) / itemsPerView;
            (ref = containerRef.current) === null || ref === void 0 ? void 0 : ref.style.setProperty("--item-width", "".concat(itemWidth, "px"));
            setSlideOffset(itemWidth + gapInPixels);
        });
        resizeObserver.observe(containerRef.current);
        return function() {
            return resizeObserver.disconnect();
        };
    }, [
        itemsPerView,
        gapInPixels
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (!isTransitioning) return undefined;
        var timer = setTimeout(function() {
            setIsTransitioning(false);
            // When we reach the third set, jump back to equivalent position in second set
            if (currentSlide >= totalSteps * 2) {
                setCurrentSlide(currentSlide - totalSteps);
            }
            // When we reach the first set, jump to equivalent position in second set
            if (currentSlide < totalSteps) {
                setCurrentSlide(currentSlide + totalSteps);
            }
        }, 300);
        return function() {
            clearTimeout(timer);
        };
    }, [
        currentSlide,
        isTransitioning,
        totalSteps
    ]);
    var amplitudeEventButtonClick = function() {
        (0,_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .trackAmplitudeEvent */ .rG)(_lib_analyticsHelper__WEBPACK_IMPORTED_MODULE_2__/* .AmplitudeEvent.seoFeatureInteracted */ .Sj.seoFeatureInteracted, {
            feature_name: "Rotate Article Carousel"
        });
    };
    var goToNextSlide = function() {
        if (isTransitioning) {
            return;
        }
        setIsTransitioning(true);
        amplitudeEventButtonClick();
        setCurrentSlide(function(curr) {
            var newSlide = curr + 1;
            return newSlide;
        });
    };
    var goToPrevSlide = function() {
        if (isTransitioning) {
            return;
        }
        setIsTransitioning(true);
        amplitudeEventButtonClick();
        setCurrentSlide(function(curr) {
            var newSlide = curr - 1;
            return newSlide;
        });
    };
    var handleTouchStart = function(e) {
        touchStartX.current = e.touches[0].clientX;
    };
    var handleTouchEnd = function(e) {
        var ref;
        var ref1;
        var endX = (ref1 = (ref = e.changedTouches[0]) === null || ref === void 0 ? void 0 : ref.clientX) !== null && ref1 !== void 0 ? ref1 : 0;
        if (Math.abs(touchStartX.current - endX) > 50) {
            if (touchStartX.current - endX > 0) {
                goToNextSlide();
            } else {
                goToPrevSlide();
            }
        }
        touchStartX.current = 0;
        touchEndX.current = 0;
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
        display: "flex",
        alignItems: "center",
        children: [
            controlVariant === "sides" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                mr: 5,
                zIndex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    onClick: goToPrevSlide,
                    size: "small",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z, {})
                })
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ref: containerRef,
                sx: {
                    "--item-width": "auto",
                    position: "relative",
                    width: "100%"
                },
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_8__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)({
                        onTouchStart: handleTouchStart,
                        onTouchEnd: handleTouchEnd,
                        sx: {
                            display: "flex",
                            overflow: "hidden",
                            width: "100%"
                        }
                    }, slotProps), {
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                            sx: {
                                display: "flex",
                                transform: "translateX(-".concat(currentSlide * slideOffset, "px)"),
                                transition: isTransitioning ? "transform 0.3s ease-in-out" : "none"
                            },
                            children: slides.map(function(slide, index) {
                                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                                    "aria-hidden": index < currentSlide || index > currentSlide + itemsPerView - 1,
                                    sx: {
                                        width: "var(--item-width)",
                                        flexShrink: 0,
                                        mr: index === slides.length - 1 ? 0 : itemGap,
                                        "& img": {
                                            width: "100%",
                                            height: "auto",
                                            objectFit: "cover",
                                            display: "block",
                                            maxWidth: "100%",
                                            aspectRatio: "3/2"
                                        },
                                        p: 1
                                    },
                                    children: slide
                                }, "carousel-slide-".concat(index + 1));
                            })
                        })
                    })),
                    controlVariant === "topRight" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            display: "flex",
                            justifyContent: "flex-end",
                            position: "absolute",
                            top: "-85px",
                            right: "0",
                            width: "100%"
                        },
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                sx: {
                                    mr: 2
                                },
                                onClick: goToPrevSlide,
                                size: "large",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_10__/* ["default"] */ .Z, {})
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                                onClick: goToNextSlide,
                                size: "large",
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_embrace_icons__WEBPACK_IMPORTED_MODULE_11__/* ["default"] */ .Z, {})
                            })
                        ]
                    }),
                    showProgressIndicator && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                        sx: {
                            mt: {
                                xs: 2,
                                md: 6
                            },
                            "& ul .dot": {
                                height: "5px"
                            }
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_12__/* ["default"] */ .Z, {
                            stepNumber: currentSlide % totalSteps + 1,
                            totalSteps: totalSteps
                        })
                    })
                ]
            }),
            controlVariant === "sides" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_mui_material__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z, {
                ml: 5,
                zIndex: 1,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_component_lib__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z, {
                    onClick: goToNextSlide,
                    size: "small",
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_care_react_icons__WEBPACK_IMPORTED_MODULE_13__/* ["default"] */ .Z, {})
                })
            })
        ]
    });
};


/***/ }),

/***/ 99207:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$I": function() { return /* binding */ SegmentationFiltersContext; },
/* harmony export */   "RZ": function() { return /* binding */ useSegmentationFiltersContext; }
/* harmony export */ });
/* unused harmony export filtersCtx */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* eslint-disable @typescript-eslint/no-unused-vars */ 
var filtersCtx = {
    filters: {
        __typename: "SEOSegmentationFilters",
        location: {
            __typename: "SEOLocationFilters",
            zipcode: "",
            city: "",
            state: null
        }
    },
    setFilters: function(_filters, _reset) {},
    fetchResults: function(_filterVals, _resetPage) {}
};
var SegmentationFiltersContext = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_0__.createContext)(filtersCtx);
var useSegmentationFiltersContext = function() {
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useContext)(SegmentationFiltersContext);
};


/***/ }),

/***/ 86460:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "F": function() { return /* binding */ Redirecting; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Loader/Loader.js
var Loader = __webpack_require__(4806);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@mui/material/SvgIcon/SvgIcon.js + 1 modules
var SvgIcon = __webpack_require__(53219);
;// CONCATENATED MODULE: ./src/components/page/RedirectingBackdrop/components/ViatorLogo.tsx




var ViatorLogo = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SvgIcon/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
            width: "128",
            height: "32",
            viewBox: "0 0 128 32",
            fill: "none",
            xmlns: "http://www.w3.org/2000/svg",
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                    width: "128",
                    height: "32",
                    fill: "#F5F5F5"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M-2655 -1175C-2655 -1176.1 -2654.1 -1177 -2653 -1177H2606C2607.1 -1177 2608 -1176.1 2608 -1175V2482C2608 2483.1 2607.1 2484 2606 2484H-2653C-2654.1 2484 -2655 2483.1 -2655 2482V-1175Z",
                    fill: "#EEEEEE"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                    d: "M-2653 -1176H2606V-1178H-2653V-1176ZM2607 -1175V2482H2609V-1175H2607ZM2606 2483H-2653V2485H2606V2483ZM-2654 2482V-1175H-2656V2482H-2654ZM-2653 2483C-2653.55 2483 -2654 2482.55 -2654 2482H-2656C-2656 2483.66 -2654.66 2485 -2653 2485V2483ZM2607 2482C2607 2482.55 2606.55 2483 2606 2483V2485C2607.66 2485 2609 2483.66 2609 2482H2607ZM2606 -1176C2606.55 -1176 2607 -1175.55 2607 -1175H2609C2609 -1176.66 2607.66 -1178 2606 -1178V-1176ZM-2653 -1178C-2654.66 -1178 -2656 -1176.66 -2656 -1175H-2654C-2654 -1175.55 -2653.55 -1176 -2653 -1176V-1178Z",
                    fill: "black",
                    fillOpacity: "0.1"
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                    clipPath: "url(#clip0_416_30439)",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                            width: "1440",
                            height: "1024",
                            transform: "translate(-656 -358)",
                            fill: "white"
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                            clipPath: "url(#clip1_416_30439)",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M125.067 27.1301C126.056 27.0752 126.907 27.844 126.962 28.8601C127.017 29.8487 126.248 30.6999 125.232 30.7549C124.244 30.8098 123.392 30.0409 123.337 29.0249C123.337 28.9974 123.337 28.9699 123.337 28.9425C123.337 27.9539 124.106 27.1575 125.067 27.1301ZM125.067 26.8555C123.914 26.8555 123.008 27.7891 123.008 28.915C123.008 30.0683 123.941 30.9745 125.067 30.9745C126.193 30.9745 127.127 30.0409 127.127 28.915C127.154 27.7891 126.221 26.8555 125.067 26.8555ZM125.369 28.9699C125.617 28.915 125.809 28.6953 125.809 28.4207C125.809 28.0363 125.479 27.8715 125.012 27.8715H124.408V29.931H124.765V28.9974H125.04L125.479 29.6839C125.617 29.9036 125.644 29.9036 125.836 29.9036H126.001V29.931L125.369 28.9699ZM125.012 28.9425H124.765V28.0088H124.985C125.342 28.0088 125.479 28.1461 125.479 28.4756C125.479 28.8052 125.369 28.9425 125.012 28.9425Z",
                                    fill: "#196C6E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M35.884 6.15234H28.25V30.9766H35.884V6.15234Z",
                                    fill: "#196C6E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M77.6973 28.5042C75.4455 28.5042 74.3746 27.1586 74.3746 24.8519V8.2109H80.4708V6.15137H74.402V-0.0546875H67.0701L66.7131 6.15137H63.4453V8.2109H66.7131V24.5773C66.7131 28.8062 69.1296 31.5523 74.0725 31.5523C77.7797 31.5523 79.9765 30.042 80.8827 28.0099L80.5257 27.6254C79.7019 28.2021 78.7133 28.5316 77.6973 28.5042Z",
                                    fill: "#196C6E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M93.6894 5.60156C85.5337 5.60156 80.3711 11.2859 80.3711 18.7002C80.3711 26.0596 85.2041 31.5517 93.5246 31.5517C102.01 31.5517 106.843 25.8674 106.843 18.4531C106.816 11.0937 101.763 5.60156 93.6894 5.60156ZM93.6345 29.7668C89.5429 29.7668 88.9662 26.444 88.9662 18.508C88.9662 10.7092 89.5154 7.33157 93.5796 7.33157C97.6712 7.33157 98.2478 10.7092 98.2478 18.6178C98.2204 26.3891 97.7261 29.7668 93.6345 29.7668Z",
                                    fill: "#196C6E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M117.517 10.4367L117.352 6.15284H109.938V30.9771H117.599V11.0957C118.066 10.9584 118.533 10.876 119.027 10.876C120.4 10.876 121.965 11.4252 126.743 13.677L127.183 13.5122V6.53729C126.304 5.9057 125.233 5.57617 124.162 5.57617C121.993 5.60363 119.494 6.94919 117.517 10.4367Z",
                                    fill: "#196C6E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M53.5404 28.0114L54.4192 30.9771H60.9548V11.8646C60.9548 7.6357 57.6321 5.57617 52.1949 5.57617C48.5426 5.57617 44.0391 6.59221 40.9636 7.60824L40.6066 11.947L41.0459 12.1667C46.895 8.23983 48.625 7.33364 50.4374 7.33364C52.497 7.33364 53.3482 8.4046 53.3482 10.6564V15.8189C44.6982 17.6038 39.4258 18.9219 39.4258 24.7985C39.4258 28.8352 42.1169 31.5537 46.4557 31.5537C49.7784 31.5537 52.2498 29.9885 53.5404 28.0114ZM46.9774 23.398C46.9774 19.581 48.268 18.6199 53.3757 17.5489V27.1052C52.442 27.8466 51.2887 28.231 50.1079 28.1761C47.9385 28.1761 46.9774 26.9404 46.9774 23.398Z",
                                    fill: "#196C6E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M20.3948 14.9655C22.9731 14.9655 25.0631 12.8754 25.0631 10.2972C25.0631 7.71896 22.9731 5.62891 20.3948 5.62891C17.8166 5.62891 15.7266 7.71896 15.7266 10.2972C15.7266 12.8754 17.8166 14.9655 20.3948 14.9655Z",
                                    fill: "#196C6E"
                                }),
                                /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                                    d: "M15.2642 31.004L17.7081 25.5394L9.08556 6.15234H0.902344L11.9689 31.004H15.2642Z",
                                    fill: "#196C6E"
                                })
                            ]
                        })
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)("defs", {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip0_416_30439",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "1440",
                                height: "1024",
                                fill: "white",
                                transform: "translate(-656 -358)"
                            })
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                            id: "clip1_416_30439",
                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("rect", {
                                width: "126.061",
                                height: "32",
                                fill: "white",
                                transform: "translate(0.96875)"
                            })
                        })
                    ]
                })
            ]
        })
    }));
};

;// CONCATENATED MODULE: ./src/components/page/RedirectingBackdrop/components/Redirecting.tsx




var VendorToLogoMap = {
    VIATOR: /*#__PURE__*/ (0,jsx_runtime.jsx)(ViatorLogo, {
        sx: {
            width: "auto",
            height: "auto"
        }
    })
};
var VendorToStringMap = {
    VIATOR: "Viator"
};
var Redirecting = function(param) {
    var provider = param.provider;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
        sx: {
            width: "100vw",
            height: "100vh"
        },
        alignItems: "center",
        justifyContent: "center",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            gap: 4,
            alignItems: "center",
            maxWidth: 500,
            children: [
                VendorToLogoMap[provider],
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    alignItems: "center",
                    textAlign: "center",
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            typography: {
                                xs: "h2",
                                md: "display3"
                            },
                            sx: {
                                m: 0,
                                mb: 2,
                                maxWidth: {
                                    xs: "95%",
                                    md: "100%"
                                }
                            },
                            children: [
                                "Redirecting you to ",
                                VendorToStringMap[provider],
                                " for more details and booking..."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                            typography: {
                                xs: "body2",
                                md: "body1"
                            },
                            sx: {
                                maxWidth: {
                                    xs: "80%"
                                },
                                mb: {
                                    xs: 1,
                                    md: 4
                                }
                            },
                            children: [
                                "You’ll be able to explore availability, pricing, and more on",
                                " ",
                                "".concat(VendorToStringMap[provider], "'s"),
                                " website."
                            ]
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
                    ]
                })
            ]
        })
    });
};


/***/ }),

/***/ 56156:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* reexport */ campsAndActivities_CampsAndActivitiesListingPage; }
});

// UNUSED EXPORTS: getServerSideProps

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_sliced_to_array.mjs + 2 modules
var _sliced_to_array = __webpack_require__(828);
// EXTERNAL MODULE: ./node_modules/tslib/tslib.es6.mjs
var tslib_es6 = __webpack_require__(97582);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/router.js
var next_router = __webpack_require__(11163);
// EXTERNAL MODULE: ./node_modules/@care/navigation/dist/components/CoreGlobalFooter/CoreGlobalFooter.js + 13 modules
var CoreGlobalFooter = __webpack_require__(79976);
// EXTERNAL MODULE: ./node_modules/@mui/material/Grid/Grid.js + 2 modules
var Grid = __webpack_require__(86886);
// EXTERNAL MODULE: ./node_modules/@mui/material/Container/Container.js
var Container = __webpack_require__(46574);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 1 modules
var Box = __webpack_require__(80822);
// EXTERNAL MODULE: ./node_modules/@apollo/client/react/hooks/useLazyQuery.js + 2 modules
var useLazyQuery = __webpack_require__(45910);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/Filter/context/FilterProvider.js + 8 modules
var FilterProvider = __webpack_require__(91188);
// EXTERNAL MODULE: ./node_modules/@care/seeker-react-components/dist/components/GoogleMaps/ZipCodeAddressSearchViewAutoComplete.js
var ZipCodeAddressSearchViewAutoComplete = __webpack_require__(5960);
// EXTERNAL MODULE: ./node_modules/@care/seeker-react-components/dist/components/GoogleMaps/index.js + 2 modules
var GoogleMaps = __webpack_require__(96041);
// EXTERNAL MODULE: ./src/components/common/SeoGlobalNavbar.tsx + 10 modules
var SeoGlobalNavbar = __webpack_require__(28528);
// EXTERNAL MODULE: ./src/components/PageMeta.tsx
var PageMeta = __webpack_require__(96301);
// EXTERNAL MODULE: ./src/lib/ApolloClient.ts + 53 modules
var ApolloClient = __webpack_require__(16064);
;// CONCATENATED MODULE: ./src/utils/getQueryParams.ts
var getQueryParams = function(query) {
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10;
    var local = query.local !== undefined;
    var pageNumber = Number((ref = query.segment) === null || ref === void 0 ? void 0 : ref.toString().split("-page")[1]) || Number((ref1 = query.local) === null || ref1 === void 0 ? void 0 : ref1.toString().split("-page")[1]) || 1;
    var seoSegmentId = local ? "/".concat((ref3 = (ref2 = query.segment) === null || ref2 === void 0 ? void 0 : ref2.toString().split("-page")) === null || ref3 === void 0 ? void 0 : ref3[0], "/").concat((ref5 = (ref4 = query.local) === null || ref4 === void 0 ? void 0 : ref4.toString().split("-page")) === null || ref5 === void 0 ? void 0 : ref5[0]) : "/".concat((ref7 = (ref6 = query.segment) === null || ref6 === void 0 ? void 0 : ref6.toString().split("-page")) === null || ref7 === void 0 ? void 0 : ref7[0]);
    var location = ((ref9 = (ref8 = query.local) === null || ref8 === void 0 ? void 0 : ref8.toString().split("-page")) === null || ref9 === void 0 ? void 0 : ref9[0]) || "";
    var ref11;
    var queryParams = {
        seoSegmentId: seoSegmentId,
        local: local,
        pageNumber: pageNumber,
        location: location,
        testIDToFireTestExposureEvent: typeof query.testIDToFireTestExposureEvent === "string" ? query.testIDToFireTestExposureEvent : (ref11 = (ref10 = query.testIDToFireTestExposureEvent) === null || ref10 === void 0 ? void 0 : ref10[query.testIDToFireTestExposureEvent.length]) !== null && ref11 !== void 0 ? ref11 : ""
    };
    return queryParams;
};
/* harmony default export */ var utils_getQueryParams = (getQueryParams);

// EXTERNAL MODULE: ./src/constants.ts
var constants = __webpack_require__(42660);
// EXTERNAL MODULE: ./src/utils/getDeviceCharacteristics.ts
var getDeviceCharacteristics = __webpack_require__(93867);
// EXTERNAL MODULE: ./src/utils/reqHeaderToEntriesObj.ts
var reqHeaderToEntriesObj = __webpack_require__(28906);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_tagged_template_literal.mjs
var _tagged_template_literal = __webpack_require__(7297);
// EXTERNAL MODULE: ./node_modules/graphql-tag/lib/index.js + 12 modules
var lib = __webpack_require__(68806);
// EXTERNAL MODULE: ./src/API/fragments/common.ts
var common = __webpack_require__(37349);
// EXTERNAL MODULE: ./src/API/utils.ts
var utils = __webpack_require__(36630);
;// CONCATENATED MODULE: ./src/API/seoActivitySegmentationListingPage.ts



function _templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  query seoActivitySegmentationListingPage(\n    $seoSegmentId: ID!\n    $pageNumber: Int\n    $filters: SEOSegmentationFilterInput\n    $ipAddress: String!\n    $userGeoInfo: String!\n    $botInfo: String!\n    $userAgent: String!\n    $local: Boolean!\n    $locationId: ID!\n  ) {\n    seoSegmentationSearchResults(\n      filters: $filters\n      pageNumber: $pageNumber\n      testCell: null\n      seoSegmentId: $seoSegmentId\n      ipAddress: $ipAddress\n      botInfo: $botInfo\n      userGeoInfo: $userGeoInfo\n      userAgent: $userAgent\n    ) {\n      ... on SEOSegmentationSearchResultsSuccess {\n        ...ActivitySearchResultFields\n        tests {\n          testName\n          testVariant\n        }\n        filters {\n          location {\n            city\n            state\n            zipcode\n          }\n        }\n      }\n      ... on SEOSegmentationSearchResultsError {\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n    seoActivityCategoryLinkSections {\n      ... on SEOActivityCategoryLinkSectionsSuccess {\n        __typename\n        linkSections {\n          id\n          linkList {\n            content\n            url\n          }\n          title\n        }\n      }\n      ... on SEOActivityCategoryLinkSectionsError {\n        __typename\n        error {\n          message\n        }\n      }\n    }\n    seoSegmentationActivityDetails(seoSegmentId: $seoSegmentId) {\n      ... on SEOSegmentationActivityDetailsSuccess {\n        segmentDetails {\n          category\n          headline\n          location {\n            city\n            state\n          }\n          pageType\n          searchingFor\n          segmentNamePlural\n          segmentNamePluralLowerCase\n          segmentNameSingular\n          segmentNameSingularLowerCase\n          seoPageMetadata {\n            canonicalURL\n            hrefLangLinks {\n              countryCode\n              languageCode\n              url\n            }\n            indexable\n            metaDescriptions\n            metaKeywords\n            seoPageId\n            title\n          }\n          serviceIdForMember\n          subcategory\n        }\n      }\n      ... on SEOSegmentationActivityDetailsError {\n        errors {\n          message\n        }\n      }\n    }\n    seoSegmentationBreadcrumbs(seoSegmentId: $seoSegmentId) {\n      ... on SEOSegmentationBreadcrumbsSuccess {\n        breadcrumbs {\n          content\n          url\n        }\n      }\n      ... on SEOSegmentationBreadcrumbsError {\n        errors {\n          message\n        }\n      }\n    }\n    getSEOSegmentationFAQs(seoSegmentId: $seoSegmentId) {\n      title\n      faqList {\n        question\n        answer\n      }\n    }\n    getSEOSegmentationLinkSections(seoSegmentId: $seoSegmentId) {\n      id\n      linkList {\n        content\n        createDate\n        description\n        url\n        imageDetails {\n          imageHeight\n          imageSize\n          imageUrl\n          imageWidth\n        }\n      }\n      title\n    }\n    seoArticlesList(seoSegmentId: $seoSegmentId) {\n      ... on SEOArticlesListSuccess {\n        __typename\n        seoArticlesList {\n          articles {\n            createDate\n            description\n            largeImage {\n              imageHeight\n              imageSize\n              imageUrl\n              imageWidth\n            }\n            smallImage {\n              imageHeight\n              imageSize\n              imageUrl\n              imageWidth\n            }\n            title\n            url\n          }\n        }\n      }\n      ... on SEOArticlesListError {\n        __typename\n        errors {\n          message\n        }\n      }\n    }\n    seoNavigationLinkSection(locationId: $locationId) @include(if: $local) {\n      ... on SEONavigationLinkSectionSuccess {\n        __typename\n        seoNavigationLinkSection {\n          childCareLinks {\n            title\n            urlPath\n          }\n          housekeepingLinks {\n            title\n            urlPath\n          }\n          jobsLinks {\n            title\n            urlPath\n          }\n          petCareLinks {\n            title\n            urlPath\n          }\n          seniorCareLinks {\n            title\n            urlPath\n          }\n          tutoringLinks {\n            title\n            urlPath\n          }\n          adultCareLinks {\n            title\n            urlPath\n          }\n        }\n      }\n      ... on SEONavigationLinkSectionError {\n        __typename\n        errors {\n          message\n        }\n      }\n    }\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}



var SEO_ACTIVITY_LISTING_PAGE = (0,lib/* gql */.Ps)(_templateObject(), common/* ACTIVITY_SEARCH_RESULT_FIELDS */.CT);
var seoActivitySegmentationListingPage = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(client, variables) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                (0,utils/* apolloClientQuery */.M)(client, SEO_ACTIVITY_LISTING_PAGE, variables)
            ];
        });
    });
    return function seoActivitySegmentationListingPage(client, variables) {
        return _ref.apply(this, arguments);
    };
}();

// EXTERNAL MODULE: ./src/__generated__/globalTypes.ts
var globalTypes = __webpack_require__(79967);
// EXTERNAL MODULE: ./node_modules/universal-cookie/es6/index.js + 2 modules
var es6 = __webpack_require__(65885);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/Banners/ProviderSignUpBanner/ProviderSignUpBanner.js + 2 modules
var ProviderSignUpBanner = __webpack_require__(38457);
// EXTERNAL MODULE: ./node_modules/next/config.js
var config = __webpack_require__(11752);
var config_default = /*#__PURE__*/__webpack_require__.n(config);
// EXTERNAL MODULE: ./src/lib/analyticsHelper.tsx
var analyticsHelper = __webpack_require__(883);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ProviderSignUpBanner.tsx






var PROVIDER_SIGN_UP_BANNER_COOKIE_KEY = "providerSignUpBannerDismissed";
var TIME_TO_LIVE = 60 * 60 * 24; // 1 day
var ProviderSignUpBanner_ProviderSignUpBanner = function(param) {
    var learnMoreUrl = param.learnMoreUrl;
    var cookies = (0,react.useMemo)(function() {
        return new es6/* default */.Z();
    }, []);
    var publicRuntimeConfig = config_default()().publicRuntimeConfig;
    var _NEXT_PUBLIC_APP_URL;
    var currentDomain = (_NEXT_PUBLIC_APP_URL = publicRuntimeConfig.NEXT_PUBLIC_APP_URL) !== null && _NEXT_PUBLIC_APP_URL !== void 0 ? _NEXT_PUBLIC_APP_URL : "";
    var defaultSignupUrl = "".concat(currentDomain, "/explore/joinus?source=marketplace");
    var finalLearnMoreUrl = learnMoreUrl !== null && learnMoreUrl !== void 0 ? learnMoreUrl : defaultSignupUrl;
    var ref = (0,react.useState)(true), isBannerVisible = ref[0], setIsBannerVisible = ref[1];
    (0,react.useEffect)(function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.lybBannerShown */.Sj.lybBannerShown);
    }, []);
    var handleBannerClose = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.lybBannerClosed */.Sj.lybBannerClosed);
        cookies.set(PROVIDER_SIGN_UP_BANNER_COOKIE_KEY, "true", {
            path: "/",
            maxAge: TIME_TO_LIVE
        });
        setIsBannerVisible(false);
    };
    var handleLearnMoreClick = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.ctaInteracted */.Sj.ctaInteracted, {
            cta_text: "Learn More",
            cta_type: "List Your Business Banner"
        });
        cookies.set(PROVIDER_SIGN_UP_BANNER_COOKIE_KEY, "true", {
            path: "/",
            maxAge: TIME_TO_LIVE
        });
        setIsBannerVisible(false);
        globalThis.open(finalLearnMoreUrl, "_blank");
    };
    return isBannerVisible ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderSignUpBanner/* default */.Z, {
        onClose: handleBannerClose,
        onAction: handleLearnMoreClick
    }) : null;
};

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/helpers/getProviderBannerVisibility.ts



/**
 * Helper function to determine if the provider signup banner should be displayed
 * Takes into account both the feature flag and the cookie state
 *
 * @param req - Server request object to access cookies
 * @param ldClientFlags - Feature flags object
 * @returns boolean indicating if the banner should be shown
 */ function getProviderBannerVisibility(req, ldClientFlags) {
    var ref, ref1;
    // Check if feature flag is enabled
    var isFlagEnabled = (ldClientFlags === null || ldClientFlags === void 0 ? void 0 : (ref = ldClientFlags[constants/* UI_FEATURE_FLAGS.PROVIDER_SIGNUP_BANNER.id */.WV.PROVIDER_SIGNUP_BANNER.id]) === null || ref === void 0 ? void 0 : ref.value) === true;
    if (!isFlagEnabled) {
        return false;
    }
    // On server-side, check for the cookie in the request
    if (req === null || req === void 0 ? void 0 : (ref1 = req.headers) === null || ref1 === void 0 ? void 0 : ref1.cookie) {
        var cookies = new es6/* default */.Z(req.headers.cookie);
        var cookieValue = cookies.get(PROVIDER_SIGN_UP_BANNER_COOKIE_KEY);
        if (cookieValue === "true" || cookieValue === true) {
            return false;
        }
    }
    // If client-side or no cookie is found, show the banner
    return true;
}

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/campsAndActivitiesPageListingProps.ts












var isLocal = "production" === "development";
var getClientFeatureFlags = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(req) {
        var flagsToFetch, _careContext, ldClient, ldUser, ldClientFlags, promises;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    flagsToFetch = [
                        constants/* UI_FEATURE_FLAGS.OHPN_DIRECTORY_SORT_BY */.WV.OHPN_DIRECTORY_SORT_BY,
                        constants/* UI_FEATURE_FLAGS.OHPN_FILTER_BY_CAMPS */.WV.OHPN_FILTER_BY_CAMPS,
                        constants/* UI_FEATURE_FLAGS.PROVIDER_SIGNUP_BANNER */.WV.PROVIDER_SIGNUP_BANNER,
                        constants/* UI_FEATURE_FLAGS.OOH_ACTIVITIES_COOKING_CATEGORY */.WV.OOH_ACTIVITIES_COOKING_CATEGORY
                    ];
                    _careContext = req.careContext, ldClient = _careContext.ldClient, ldUser = _careContext.ldUser;
                    ldClientFlags = {};
                    if (!(ldClient && ldUser)) return [
                        3,
                        2
                    ];
                    promises = flagsToFetch.map(function() {
                        var _ref = (0,_async_to_generator/* default */.Z)(function(flag) {
                            var _;
                            return (0,tslib_es6.__generator)(this, function(_state) {
                                switch(_state.label){
                                    case 0:
                                        _ = flag.id;
                                        return [
                                            4,
                                            ldClient.variationDetail(flag.id, ldUser, undefined)
                                        ];
                                    case 1:
                                        ldClientFlags[_] = _state.sent();
                                        return [
                                            2
                                        ];
                                }
                            });
                        });
                        return function(flag) {
                            return _ref.apply(this, arguments);
                        };
                    }());
                    return [
                        4,
                        Promise.all(promises)
                    ];
                case 1:
                    _state.sent();
                    _state.label = 2;
                case 2:
                    return [
                        2,
                        ldClientFlags
                    ];
            }
        });
    });
    return function getClientFeatureFlags(req) {
        return _ref.apply(this, arguments);
    };
}();
var flaggedFilterParams = function(isDirectorySortEnabled, zipcode) {
    var filters = zipcode ? {
        zipcode: zipcode
    } : null;
    if (isDirectorySortEnabled) {
        filters = (0,_object_spread/* default */.Z)({
            sortBy: globalTypes/* EventsSortBy.RECOMMENDED */.fC.RECOMMENDED
        }, zipcode ? {
            zipcode: zipcode
        } : {});
    }
    return filters;
};
var getListPageData = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(param) {
        var query, req, res, ref, ref1, ref2, ref3, ref4, ref5, startPageGSSP, apolloOptions, startApolloClient, apolloClient, stopApolloClient, serverFeatureFlags, ldClientFlags, ref6, userAgent, ref7, deviceCharHeader, deviceChar, ref8, seoSegmentId, pageNumber, local, location, zipcode, seoSegmentIdNew, ref9, botInfo, ref10, userGeoInfo, ipAddressArray, ipAddress, ref11, startGetPageData, isDirectorySortEnabled, seoSegmentationListingPage, stopGetPageData, seoSegmentationListingPageData, showProviderSignUpBanner, _seoNavigationLinkSection, pageProps, stopPageGSSP;
        return (0,tslib_es6.__generator)(this, function(_state) {
            switch(_state.label){
                case 0:
                    query = param.query, req = param.req, res = param.res;
                    startPageGSSP = performance.now();
                    apolloOptions = {
                        logError: req.log.error.bind(req.log),
                        logInfo: req.log.info.bind(req.log)
                    };
                    startApolloClient = performance.now();
                    apolloClient = (0,ApolloClient/* getApolloClient */.W)(apolloOptions);
                    stopApolloClient = performance.now();
                    serverFeatureFlags = (ref = req.careContext) === null || ref === void 0 ? void 0 : ref.ldServerFlags;
                    return [
                        4,
                        getClientFeatureFlags(req)
                    ];
                case 1:
                    ldClientFlags = _state.sent();
                    userAgent = (ref6 = req.headers["user-agent"]) !== null && ref6 !== void 0 ? ref6 : "";
                    deviceCharHeader = (ref7 = (ref1 = req.headers["x-akamai-device-characteristics"]) === null || ref1 === void 0 ? void 0 : ref1.toString()) !== null && ref7 !== void 0 ? ref7 : "";
                    deviceChar = isLocal ? (0,getDeviceCharacteristics/* default */.Z)(userAgent, deviceCharHeader) : (0,reqHeaderToEntriesObj/* default */.Z)(deviceCharHeader, ";");
                    ref8 = utils_getQueryParams(query), seoSegmentId = ref8.seoSegmentId, pageNumber = ref8.pageNumber, local = ref8.local, location = ref8.location;
                    zipcode = query.zipCode;
                    seoSegmentIdNew = "/explore/d".concat(seoSegmentId);
                    botInfo = (ref9 = (ref2 = req.headers["Akamai-Bot"]) === null || ref2 === void 0 ? void 0 : ref2.toString()) !== null && ref9 !== void 0 ? ref9 : "";
                    userGeoInfo = (ref10 = (ref3 = req.headers["x-akamai-edgescape"]) === null || ref3 === void 0 ? void 0 : ref3.toString()) !== null && ref10 !== void 0 ? ref10 : "";
                    ipAddressArray = req.headers["x-forwarded-for"];
                    if (typeof ipAddressArray !== "undefined") {
                        ;
                        ref11 = (0,_sliced_to_array/* default */.Z)(ipAddressArray.toString().split(","), 1), ipAddress = ref11[0], ref11;
                    } else {
                        ipAddress = "";
                    }
                    startGetPageData = performance.now();
                    if (serverFeatureFlags === null || serverFeatureFlags === void 0 ? void 0 : (ref4 = serverFeatureFlags[constants/* SERVER_FEATURE_FLAGS.SEO_MFE_LOG_AKAMAI_HEADER */.VL.SEO_MFE_LOG_AKAMAI_HEADER]) === null || ref4 === void 0 ? void 0 : ref4.value) {
                        req.log.info({
                            event: "x-akamai-edgescape header",
                            seoSegmentId: seoSegmentId,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            ipAddress: ipAddress,
                            akamaiHeader: userGeoInfo
                        });
                    }
                    isDirectorySortEnabled = (ref5 = ldClientFlags[constants/* UI_FEATURE_FLAGS.OHPN_DIRECTORY_SORT_BY.id */.WV.OHPN_DIRECTORY_SORT_BY.id]) === null || ref5 === void 0 ? void 0 : ref5.value;
                    return [
                        4,
                        seoActivitySegmentationListingPage(apolloClient, {
                            filters: flaggedFilterParams(isDirectorySortEnabled, typeof zipcode === "string" ? zipcode : undefined),
                            pageNumber: pageNumber,
                            seoSegmentId: seoSegmentIdNew,
                            ipAddress: ipAddress,
                            botInfo: botInfo,
                            userGeoInfo: userGeoInfo,
                            userAgent: userAgent,
                            local: local,
                            locationId: location
                        })
                    ];
                case 2:
                    seoSegmentationListingPage = _state.sent();
                    stopGetPageData = performance.now();
                    if (seoSegmentationListingPage.error !== null) {
                        req.log.error({
                            event: "SeoListingPageLoadError",
                            seoSegmentId: seoSegmentIdNew,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            errors: seoSegmentationListingPage.error
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    seoSegmentationListingPageData = seoSegmentationListingPage.queryResponse.data;
                    if (seoSegmentationListingPageData.seoSegmentationActivityDetails.__typename === "SEOSegmentationActivityDetailsError" || seoSegmentationListingPageData.seoSegmentationSearchResults.__typename === "SEOSegmentationSearchResultsError" || seoSegmentationListingPage.queryResponse.errors) {
                        req.log.error({
                            event: "SeoListingPageLoadError",
                            seoSegmentId: seoSegmentIdNew,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            errors: seoSegmentationListingPage.queryResponse.errors
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    if (seoSegmentationListingPageData.seoSegmentationActivityDetails.segmentDetails === null) {
                        req.log.error({
                            event: "SeoListingPageLoadError",
                            seoSegmentId: seoSegmentIdNew,
                            userAgent: userAgent,
                            deviceChar: deviceChar,
                            query: query,
                            res: res,
                            errorMsg: "ERROR - seoSegmentationActivityDetails is null"
                        });
                        return [
                            2,
                            {
                                notFound: true
                            }
                        ];
                    }
                    showProviderSignUpBanner = getProviderBannerVisibility(req, ldClientFlags);
                    pageProps = {
                        props: {
                            initialPageNumber: pageNumber,
                            seoSegmentId: seoSegmentIdNew,
                            ipAddress: ipAddress,
                            botInfo: botInfo,
                            userGeoInfo: userGeoInfo,
                            userAgent: userAgent,
                            pageData: {
                                seoSegmentationSearchResults: seoSegmentationListingPageData.seoSegmentationSearchResults,
                                seoSegmentationActivityDetails: seoSegmentationListingPageData.seoSegmentationActivityDetails.segmentDetails,
                                seoSegmentationBreadcrumbs: seoSegmentationListingPageData.seoSegmentationBreadcrumbs,
                                getSEOSegmentationFAQs: seoSegmentationListingPageData.getSEOSegmentationFAQs,
                                getSEOSegmentationLinkSections: seoSegmentationListingPageData.getSEOSegmentationLinkSections,
                                seoNavigationLinkSection: (_seoNavigationLinkSection = seoSegmentationListingPageData.seoNavigationLinkSection) !== null && _seoNavigationLinkSection !== void 0 ? _seoNavigationLinkSection : null,
                                seoArticlesList: seoSegmentationListingPageData.seoArticlesList,
                                seoActivityCategoryLinkSections: seoSegmentationListingPageData.seoActivityCategoryLinkSections
                            },
                            deviceChar: deviceChar,
                            local: local,
                            ldClientFlags: ldClientFlags,
                            showProviderSignUpBanner: showProviderSignUpBanner
                        }
                    };
                    req.log.info({
                        event: "SeoListingPageLoadSuccess",
                        deviceChar: deviceChar,
                        query: query,
                        res: res
                    });
                    stopPageGSSP = performance.now();
                    req.careContext.serverTimings.pageGSSP = stopPageGSSP - startPageGSSP;
                    req.careContext.serverTimings.apolloClient = stopApolloClient - startApolloClient;
                    req.careContext.serverTimings.pageData = stopGetPageData - startGetPageData;
                    return [
                        2,
                        pageProps
                    ];
            }
        });
    });
    return function getListPageData(_) {
        return _ref.apply(this, arguments);
    };
}();
/* harmony default export */ var campsAndActivitiesPageListingProps = (getListPageData);

// EXTERNAL MODULE: ./src/components/SearchResults/Pagination.tsx
var Pagination = __webpack_require__(6551);
// EXTERNAL MODULE: ./src/utils/filtersStorage.ts
var filtersStorage = __webpack_require__(85627);
// EXTERNAL MODULE: ./src/utils/getZipcodeFromGeoInfo.ts
var getZipcodeFromGeoInfo = __webpack_require__(7360);
;// CONCATENATED MODULE: ./src/API/getActivitySearchResults.ts

function getActivitySearchResults_templateObject() {
    var data = (0,_tagged_template_literal/* default */.Z)([
        "\n  ",
        "\n  query getActivitySearchResults(\n    $seoSegmentId: ID!\n    $pageNumber: Int\n    $filters: SEOSegmentationFilterInput\n    $ipAddress: String!\n    $userGeoInfo: String!\n    $botInfo: String!\n    $userAgent: String!\n  ) {\n    seoSegmentationSearchResults(\n      filters: $filters\n      pageNumber: $pageNumber\n      testCell: null\n      seoSegmentId: $seoSegmentId\n      ipAddress: $ipAddress\n      botInfo: $botInfo\n      userGeoInfo: $userGeoInfo\n      userAgent: $userAgent\n    ) {\n      ... on SEOSegmentationSearchResultsSuccess {\n        ...ActivitySearchResultFields\n\n        filters {\n          location {\n            zipcode\n            city\n            state\n          }\n        }\n      }\n      ... on SEOSegmentationSearchResultsError {\n        errors {\n          __typename\n          message\n        }\n      }\n    }\n    seoSegmentationActivityDetails(seoSegmentId: $seoSegmentId) {\n      ... on SEOSegmentationActivityDetailsSuccess {\n        segmentDetails {\n          category\n          headline\n          location {\n            city\n            state\n          }\n          pageType\n          searchingFor\n          segmentNamePlural\n          segmentNamePluralLowerCase\n          segmentNameSingular\n          segmentNameSingularLowerCase\n          seoPageMetadata {\n            canonicalURL\n            hrefLangLinks {\n              countryCode\n              languageCode\n              url\n            }\n            indexable\n            metaDescriptions\n            metaKeywords\n            seoPageId\n            title\n          }\n          serviceIdForMember\n          subcategory\n        }\n      }\n    }\n    seoSegmentationBreadcrumbs(seoSegmentId: $seoSegmentId) {\n      ... on SEOSegmentationBreadcrumbsSuccess {\n        breadcrumbs {\n          content\n          url\n        }\n      }\n      ... on SEOSegmentationBreadcrumbsError {\n        errors {\n          message\n        }\n      }\n    }\n    getSEOSegmentationFAQs(seoSegmentId: $seoSegmentId) {\n      title\n      faqList {\n        question\n        answer\n      }\n    }\n    getSEOSegmentationLinkSections(seoSegmentId: $seoSegmentId) {\n      id\n      linkList {\n        content\n        createDate\n        description\n        url\n        imageDetails {\n          imageHeight\n          imageSize\n          imageUrl\n          imageWidth\n        }\n      }\n      title\n    }\n    seoArticlesList(seoSegmentId: $seoSegmentId) {\n      ... on SEOArticlesListSuccess {\n        __typename\n        seoArticlesList {\n          articles {\n            createDate\n            description\n            largeImage {\n              imageHeight\n              imageSize\n              imageUrl\n              imageWidth\n            }\n            smallImage {\n              imageHeight\n              imageSize\n              imageUrl\n              imageWidth\n            }\n            title\n            url\n          }\n        }\n      }\n      ... on SEOArticlesListError {\n        __typename\n        errors {\n          message\n        }\n      }\n    }\n  }\n"
    ]);
    getActivitySearchResults_templateObject = function _templateObject() {
        return data;
    };
    return data;
}


var GET_ACTIVITY_SEARCH_RESULTS = (0,lib/* default */.ZP)(getActivitySearchResults_templateObject(), common/* ACTIVITY_SEARCH_RESULT_FIELDS */.CT);
/* harmony default export */ var API_getActivitySearchResults = (GET_ACTIVITY_SEARCH_RESULTS);

// EXTERNAL MODULE: ./src/components/hooks/useResponsive.tsx
var useResponsive = __webpack_require__(19147);
// EXTERNAL MODULE: ./src/components/Breadcrumbs.tsx
var Breadcrumbs = __webpack_require__(22284);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@mui/material/Typography/Typography.js + 1 modules
var Typography = __webpack_require__(15861);
// EXTERNAL MODULE: ./node_modules/he/he.js
var he = __webpack_require__(86492);
var he_default = /*#__PURE__*/__webpack_require__.n(he);
// EXTERNAL MODULE: ./node_modules/sanitize-html/index.js
var sanitize_html = __webpack_require__(91036);
var sanitize_html_default = /*#__PURE__*/__webpack_require__.n(sanitize_html);
;// CONCATENATED MODULE: ./src/components/FAQs.tsx






var FAQs = function(param) {
    var faqs = param.faqs;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var schemaJson = {
        "@context": "https://schema.org",
        "@type": "FAQPage",
        mainEntity: []
    };
    var formatJSON = function(faq) {
        return {
            "@type": "Question",
            name: "".concat(faq.question),
            acceptedAnswer: {
                "@type": "Answer",
                text: "".concat(faq.answer)
            }
        };
    };
    var createFaqSchema = function() {
        if (faqs.faqList) {
            schemaJson.mainEntity = faqs.faqList.map(function(faq) {
                return formatJSON(faq);
            });
        }
        return schemaJson;
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
        mt: 5,
        mb: {
            xs: 5,
            md: 10
        },
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                variant: !isSmallViewport ? "display3" : "h1",
                color: "primary",
                mb: {
                    xs: 3,
                    md: 4
                },
                fontWeight: "400",
                lineHeight: "28px",
                children: faqs.title
            }),
            faqs.faqList && faqs.faqList.map(function(faq) {
                /*#__PURE__*/ return (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                            variant: "h4",
                            color: "primary",
                            mb: 1.5,
                            children: faq.question
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            role: "dialog",
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML: {
                                __html: sanitize_html_default()(he_default().decode(faq.answer))
                            },
                            sx: function(theme) {
                                var ref;
                                return (0,_define_property/* default */.Z)({
                                    marginBottom: theme.spacing(3),
                                    fontSize: "0.875rem",
                                    fontWeight: 400,
                                    lineHeight: "20px",
                                    color: (ref = theme.palette.care.navy) === null || ref === void 0 ? void 0 : ref[900]
                                }, theme.breakpoints.up("sm"), {
                                    fontSize: "1rem",
                                    lineHeight: "22px",
                                    marginBottom: theme.spacing(4)
                                });
                            }
                        })
                    ]
                }, faq.question);
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("script", {
                type: "application/ld+json",
                // eslint-disable-next-line react/no-danger
                dangerouslySetInnerHTML: {
                    __html: JSON.stringify(createFaqSchema())
                }
            })
        ]
    });
};
/* harmony default export */ var components_FAQs = (FAQs);

// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevron.js
var Icon24UtilityChevron = __webpack_require__(68720);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24UtilityChevronUp.js
var Icon24UtilityChevronUp = __webpack_require__(66098);
// EXTERNAL MODULE: ./node_modules/@mui/material/Link/Link.js + 2 modules
var Link = __webpack_require__(23795);
// EXTERNAL MODULE: ./node_modules/@mui/material/Button/Button.js + 3 modules
var Button = __webpack_require__(69417);
// EXTERNAL MODULE: ./node_modules/@mui/material/Accordion/Accordion.js + 3 modules
var Accordion = __webpack_require__(82280);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionDetails/AccordionDetails.js + 1 modules
var AccordionDetails = __webpack_require__(22797);
// EXTERNAL MODULE: ./node_modules/@mui/material/AccordionSummary/AccordionSummary.js + 1 modules
var AccordionSummary = __webpack_require__(38895);
// EXTERNAL MODULE: ./node_modules/lodash-es/cloneDeepWith.js + 31 modules
var cloneDeepWith = __webpack_require__(43539);
;// CONCATENATED MODULE: ./src/utils/smartCapitalize.ts
/**
 * Capitalizes a string excepe small words like 'of' and 'and' for example.
 * @param  {string} str the string to capitalize
 * @return {string} capitalized string
 */ var lower = function(word) {
    return word.toLowerCase();
};
var upper = function(word) {
    return word.substr(0, 1).toUpperCase() + word.substr(1);
};
var smartCapitalize = function(str) {
    var small = "(a|an|and|as|at|but|by|en|for|if|in|of|on|or|the|to|v[.]?|via|vs[.]?)";
    var punct = "([!\"#$%&'()*+,./:;<=>?@[\\\\\\]^_`{|}~-]*)";
    var parts = [];
    var split = /[:.;?!] |(?: |^)["Ò]/g;
    var index = 0;
    while(index < str.length){
        var m = split.exec(str);
        var endIndex = m ? m.index : str.length;
        var part = str.substring(index, endIndex).replace(/\b([A-Za-z][a-z.'Õ]*)\b/g, function(all) {
            return /[A-Za-z]\.[A-Za-z]/.test(all) ? all : upper(all);
        }).replace(new RegExp("\\b".concat(small, "\\b"), "ig"), lower).replace(new RegExp("^".concat(punct).concat(small, "\\b"), "ig"), function(_all, _punct, word) {
            return _punct + upper(word);
        }).replace(new RegExp("\\b".concat(small).concat(punct, "$"), "ig"), upper);
        parts.push(part);
        if (m) {
            parts.push(m[0]);
            index = split.lastIndex;
        } else {
            break;
        }
    }
    return parts.join("").replace(/ V(s?)\. /gi, " v$1. ").replace(/(['Õ])S\b/gi, "$1s").replace(/\b(AT&T|Q&A)\b/gi, function(all) {
        return all.toUpperCase();
    });
};
/* harmony default export */ var utils_smartCapitalize = (smartCapitalize);

// EXTERNAL MODULE: ./src/components/contexts/PageAttributesContext.tsx
var PageAttributesContext = __webpack_require__(73739);
;// CONCATENATED MODULE: ./src/components/ListContainer.tsx



var ListContainer = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        display: "flex",
        flexDirection: "column",
        width: {
            xs: "100%",
            sm: "50%",
            md: "40%"
        },
        children: children
    });
};

;// CONCATENATED MODULE: ./src/components/SeoLinkList.tsx











var SeoLinkList = function(param) {
    var seoLinkList = param.seoLinkList, internalLinkingHeadline = param.internalLinkingHeadline, seoSegmentNamePlural = param.seoSegmentNamePlural;
    var ref = (0,react.useState)(false), showMore = ref[0], setShowMore = ref[1];
    var ref1 = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNameSingular = ref1.segmentNameSingular, segmentNamePlural = ref1.segmentNamePlural, pageType = ref1.pageType;
    var getResourcesTabContentIndex = function(url) {
        var sortOrderIndex = {
            stateSegmentation: 1,
            cityServices: 2,
            stateServices: 3,
            costGuide: 4
        };
        if (url.includes("/cost")) {
            return sortOrderIndex.costGuide;
        }
        if (url.includes("/all-services")) {
            var lastIndex = url.lastIndexOf("/");
            var subString = url.substring(lastIndex, url.length);
            // check if the substring is city-state or state format ('austin-tx' or 'tx')
            if (subString.includes("-")) {
                return sortOrderIndex.cityServices;
            }
            return sortOrderIndex.stateServices;
        }
        return sortOrderIndex.stateSegmentation;
    };
    var sortResourcesTabContent = function(linkLists) {
        return (0,cloneDeepWith/* default */.Z)(linkLists).sort(function(linkListA, linkListB) {
            return getResourcesTabContentIndex(linkListA.url) - getResourcesTabContentIndex(linkListB.url);
        });
    };
    var filterSeoLinkList = function(seoLinkSections) {
        return seoLinkSections.reduce(function(result, seoLink) {
            if (seoLink.id !== globalTypes/* InternalLinkSectionId.ARTICLES */.$z.ARTICLES && !seoLink.title.toLowerCase().includes("jobs") && seoLink.linkList.length > 0) {
                if (seoLink.id === globalTypes/* InternalLinkSectionId.RESOURCES */.$z.RESOURCES) {
                    var linkList = sortResourcesTabContent(seoLink.linkList);
                    result.push({
                        __typename: "SEOSegmentationLinkSection",
                        id: seoLink.id,
                        title: seoLink.title,
                        linkList: linkList
                    });
                    var jobsSeoLink = seoLinkList.find(function(_seoLink) {
                        return _seoLink.title.includes("jobs");
                    });
                    if (jobsSeoLink) {
                        jobsSeoLink.linkList.forEach(function(link) {
                            if (linkList.indexOf(link) === -1) {
                                linkList.push(link);
                            }
                        });
                    }
                } else {
                    result.push(seoLink);
                }
            }
            return result;
        }, []);
    };
    var sortTabs = function(seoLinkSections) {
        var nationalOrLocalPageType = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : undefined;
        var nationalPageTabOrder = Object.freeze({
            RELATED_SERVICES: 1,
            TOP_CITIES: 2,
            RESOURCES: 3,
            NULL_ID: 4
        });
        var localPageTabOrder = Object.freeze({
            RELATED_SERVICES: 2,
            TOP_CITIES: 1,
            RESOURCES: 3,
            NULL_ID: 4
        });
        return (0,cloneDeepWith/* default */.Z)(seoLinkSections).sort(function(linkSectionA, linkSectionB) {
            var sectionAId = linkSectionA.id ? linkSectionA.id.toString() : "NULL_ID";
            var sectionBId = linkSectionB.id ? linkSectionB.id.toString() : "NULL_ID";
            if (nationalOrLocalPageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
                return nationalPageTabOrder[sectionAId] - nationalPageTabOrder[sectionBId];
            }
            return localPageTabOrder[sectionAId] - localPageTabOrder[sectionBId];
        });
    };
    var seoLinks = sortTabs(filterSeoLinkList(seoLinkList), pageType);
    var handleClickShow = function() {
        if (showMore) {
            setShowMore(false);
        } else {
            setShowMore(true);
        }
    };
    var tabHeadline = function(title) {
        if (pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL) {
            if (title.includes("Help")) return "".concat(segmentNameSingular, " in Top Cities");
            if (title.includes("Resources")) return "More Services";
            return title;
        }
        if (title.includes("Related")) return "Sub-categories";
        if (title.includes("Near")) {
            return seoSegmentNamePlural ? "".concat(seoSegmentNamePlural, " in Nearby Cities") : "".concat(segmentNamePlural, " in Nearby Cities");
        }
        if (title.includes("Resources")) return "More Services";
        return title;
    };
    var links = function(linkList) {
        return linkList.map(function(link, index) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, {
                className: !showMore && index > 19 ? "link-hidden" : "link-visible",
                sx: {
                    "&.link-visible": {
                        cursor: "pointer",
                        lineHeight: "30px"
                    },
                    "&.link-hidden": {
                        visibility: "hidden",
                        maxHeight: "0"
                    }
                },
                href: link.url,
                underline: "none",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    component: "span",
                    variant: "body2",
                    // eslint-disable-next-line react/no-danger
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(utils_smartCapitalize(link.content)))
                    }
                })
            }, "".concat(link.content, "-").concat(index + 1));
        });
    };
    var renderLinkList = function(seoLink) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    sx: {
                        display: {
                            sm: "flex"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                            children: links(seoLink.linkList).slice(0, 10)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                            children: links(seoLink.linkList).slice(10, 20)
                        })
                    ]
                }),
                seoLink.linkList.length > 20 && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                    height: !showMore ? "0px" : "auto",
                    sx: {
                        display: {
                            sm: "flex"
                        }
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                            children: links(seoLink.linkList).slice(20, // split links evenly between the two columns
                            20 + (seoLink.linkList.length - 20) / 2)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ListContainer, {
                            children: links(seoLink.linkList).slice(20 + (seoLink.linkList.length - 20) / 2)
                        })
                    ]
                }),
                !showMore && seoLink.linkList.length > 20 && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: handleClickShow,
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                variant: "body2",
                                color: "text.primary",
                                children: "Show more"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ml: 1,
                                mt: 0.5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
                                    size: 20
                                })
                            })
                        ]
                    })
                }),
                showMore && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    display: "flex",
                    justifyContent: "center",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Button/* default */.Z, {
                        onClick: handleClickShow,
                        sx: {
                            textAlign: "center",
                            display: "flex",
                            justifyContent: "center",
                            mt: 1
                        },
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                component: "span",
                                variant: "body2",
                                children: "Show less"
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                ml: 1,
                                mt: 0.5,
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevronUp/* default */.Z, {
                                    size: 20
                                })
                            })
                        ]
                    })
                })
            ]
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        item: true,
        xs: 12,
        md: 10,
        style: {
            margin: "auto"
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Container/* default */.Z, {
            disableGutters: true,
            sx: {
                mt: 4
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "h3",
                    sx: {
                        fontSize: {
                            xs: "h3.fontSize",
                            sm: "h2.fontSize"
                        },
                        color: "default.main",
                        mb: 1.5
                    },
                    dangerouslySetInnerHTML: {
                        __html: sanitize_html_default()(he_default().decode(internalLinkingHeadline !== null && internalLinkingHeadline !== void 0 ? internalLinkingHeadline : "Additional Services"))
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Accordion/* default */.Z, {
                    defaultExpanded: true,
                    elevation: 0,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                        sx: {
                            m: 0,
                            p: 0
                        },
                        children: seoLinks.map(function(seoLink, index) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Accordion/* default */.Z, {
                                elevation: 0,
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionSummary/* default */.Z, {
                                        sx: {
                                            width: "fit-content",
                                            p: 0,
                                            "& .MuiIconButton-root": {
                                                mt: 0.5
                                            }
                                        },
                                        expandIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24UtilityChevron/* default */.Z, {
                                            color: "#172C42"
                                        }),
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                                            variant: "h3",
                                            sx: {
                                                fontSize: {
                                                    xs: "h4.fontSize",
                                                    sm: "h3.fontSize"
                                                },
                                                color: "secondary.main"
                                            },
                                            children: tabHeadline(seoLink.title)
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime.jsx)(AccordionDetails/* default */.Z, {
                                        sx: {
                                            m: 0,
                                            p: 0
                                        },
                                        children: renderLinkList(seoLink)
                                    })
                                ]
                            }, "".concat(seoLink.title, "-").concat(index + 1));
                        })
                    })
                })
            ]
        })
    });
};
/* harmony default export */ var components_SeoLinkList = (SeoLinkList);

// EXTERNAL MODULE: ./src/components/contexts/SegmentationFiltersContext.tsx
var SegmentationFiltersContext = __webpack_require__(99207);
// EXTERNAL MODULE: ./src/components/common/ArticleSection/ArticleSection.tsx
var ArticleSection = __webpack_require__(83845);
// EXTERNAL MODULE: ./node_modules/@mui/material/Stack/Stack.js + 1 modules
var Stack = __webpack_require__(51233);
// EXTERNAL MODULE: ./src/components/hooks/useFeatureFlag.ts
var useFeatureFlag = __webpack_require__(19500);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Select/Select.js
var Select = __webpack_require__(92817);
// EXTERNAL MODULE: ./node_modules/@mui/material/MenuItem/MenuItem.js + 1 modules
var MenuItem = __webpack_require__(18972);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/Filter/hooks/useFilterField.js
var useFilterField = __webpack_require__(40577);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/SortByDropdown.tsx












var _obj;
var SortByEnumToString = (_obj = {}, (0,_define_property/* default */.Z)(_obj, globalTypes/* EventsSortBy.RECOMMENDED */.fC.RECOMMENDED, "Recommended"), (0,_define_property/* default */.Z)(_obj, globalTypes/* EventsSortBy.NEWEST */.fC.NEWEST, "Newest"), _obj);
var options = [
    globalTypes/* EventsSortBy.RECOMMENDED */.fC.RECOMMENDED,
    globalTypes/* EventsSortBy.NEWEST */.fC.NEWEST
];
var defaultValue = globalTypes/* EventsSortBy.RECOMMENDED */.fC.RECOMMENDED;
var SortByDropdown = function() {
    var ref = (0,SegmentationFiltersContext/* useSegmentationFiltersContext */.RZ)(), filters = ref.filters, setFilters = ref.setFilters, fetchResults = ref.fetchResults;
    var ref1 = (0,useFilterField/* useFilterField */.A)({
        name: "sortBy",
        type: "single-select",
        label: "Sort By",
        options: options,
        defaultValue: defaultValue,
        modalProps: {
            hideInModal: true
        }
    }), value = ref1.value, setValue = ref1.setValue;
    var renderSelectValue = function(currentValue) {
        var selectedSortBy = currentValue;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
            variant: "body2",
            component: "span",
            children: [
                "Sort by: ",
                /*#__PURE__*/ (0,jsx_runtime.jsx)("b", {
                    children: SortByEnumToString[selectedSortBy]
                })
            ]
        });
    };
    var handleSortByChange = function(event) {
        var selectedValue = event.target.value;
        setValue(selectedValue);
        var _ref = filters !== null && filters !== void 0 ? filters : {}, typename = _ref.__typename, location = _ref.location, restFilters = (0,_object_without_properties/* default */.Z)(_ref, [
            "__typename",
            "location"
        ]);
        var ref;
        var zipcode = (ref = location === null || location === void 0 ? void 0 : location.zipcode) !== null && ref !== void 0 ? ref : undefined;
        var updatedFilters = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, restFilters), {
            zipcode: zipcode,
            sortBy: selectedValue
        });
        (0,filtersStorage/* saveFilters */.HJ)(updatedFilters);
        setFilters(updatedFilters);
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "Sort Applied",
            sort: SortByEnumToString[selectedValue]
        });
        fetchResults(updatedFilters, true);
    };
    var handleSelectOpen = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "Sort Viewed"
        });
    };
    var selectValue = value.length ? value : defaultValue;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Select/* default */.Z, {
        "data-testid": "sort-by-dropdown",
        value: selectValue,
        onChange: handleSortByChange,
        onOpen: handleSelectOpen,
        renderValue: renderSelectValue,
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: globalTypes/* EventsSortBy.RECOMMENDED */.fC.RECOMMENDED,
                children: SortByEnumToString[globalTypes/* EventsSortBy.RECOMMENDED */.fC.RECOMMENDED]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MenuItem/* default */.Z, {
                value: globalTypes/* EventsSortBy.NEWEST */.fC.NEWEST,
                children: SortByEnumToString[globalTypes/* EventsSortBy.NEWEST */.fC.NEWEST]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ExploreHeaderText.tsx





var ExploreHeaderText = function(param) {
    var headline = param.headline, hasResults = param.hasResults;
    var directorySortFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.OHPN_DIRECTORY_SORT_BY.id */.WV.OHPN_DIRECTORY_SORT_BY.id);
    var isDirectorySortEnabled = Boolean(directorySortFlag === null || directorySortFlag === void 0 ? void 0 : directorySortFlag.value);
    if (isDirectorySortEnabled) {
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            mb: {
                xs: 2,
                sm: 3
            },
            direction: {
                xs: "column",
                sm: "row"
            },
            alignItems: {
                xs: "stretch",
                sm: "center"
            },
            justifyContent: "space-between",
            gap: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    typography: {
                        xs: "h2",
                        md: "h1"
                    },
                    component: "h1",
                    children: headline
                }),
                hasResults && /*#__PURE__*/ (0,jsx_runtime.jsx)(SortByDropdown, {})
            ]
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        my: {
            xs: 1,
            sm: 2
        },
        mb: {
            xs: 2
        },
        mt: {
            xs: 2
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
            component: "h1",
            typography: {
                xs: "h2",
                md: "h1"
            },
            children: headline
        })
    });
};

// EXTERNAL MODULE: ./node_modules/uuid/dist/esm-browser/v4.js + 3 modules
var v4 = __webpack_require__(88773);
// EXTERNAL MODULE: ./node_modules/@mui/material/Skeleton/Skeleton.js + 2 modules
var Skeleton = __webpack_require__(88078);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/components/ActivityCardBadge/tags.js + 2 modules
var tags = __webpack_require__(6518);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/components/ActivityCardBadge/ActivityCardBadge.js
var ActivityCardBadge = __webpack_require__(13009);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/ActivityCard.js + 11 modules
var ActivityCard = __webpack_require__(42993);
;// CONCATENATED MODULE: ./src/utils/activityAgesToRangeText.ts
var formatMonths = function(months) {
    return "".concat(months, " months");
};
var formatYears = function(months) {
    return "".concat(Math.floor(months / 12), " years");
};
var formatYearsWithPlus = function(months) {
    return "".concat(Math.floor(months / 12), "+ years");
};
var activityAgesToRangeText = function(minAgeMonths, maxAgeMonths) {
    // Number of months for 18 years + 1day;
    var GROWN_THRESHOLD = 18 * 12 + 1;
    var maxAge = (maxAgeMonths !== null && maxAgeMonths !== void 0 ? maxAgeMonths : 0) >= GROWN_THRESHOLD ? 0 : maxAgeMonths;
    if (!minAgeMonths && !maxAge) {
        return "All ages";
    }
    if (!maxAge) {
        return minAgeMonths < 12 ? "".concat(minAgeMonths, "+ months") : formatYearsWithPlus(minAgeMonths);
    }
    if (!minAgeMonths) {
        return maxAge <= 12 ? "Up to ".concat(formatMonths(maxAge)) : "Up to ".concat(formatYears(maxAge));
    }
    if (minAgeMonths === maxAge) {
        return minAgeMonths < 12 ? formatMonths(minAgeMonths) : formatYears(minAgeMonths);
    }
    var minInYears = Math.floor(minAgeMonths / 12);
    var maxInYears = Math.floor(maxAge / 12);
    if (minAgeMonths < 12 && maxAge < 12) {
        return "Ages ".concat(minAgeMonths, "-").concat(maxAge, " months");
    }
    if (minAgeMonths < 12) {
        return "".concat(formatMonths(minAgeMonths), " - ").concat(formatYears(maxAge));
    }
    return "Ages ".concat(minInYears, "-").concat(maxInYears, " years");
};

// EXTERNAL MODULE: ./node_modules/@mui/material/Backdrop/Backdrop.js + 1 modules
var Backdrop = __webpack_require__(84808);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/Loader/Loader.js
var Loader = __webpack_require__(4806);
// EXTERNAL MODULE: ./src/components/page/RedirectingBackdrop/components/Redirecting.tsx + 1 modules
var Redirecting = __webpack_require__(86460);
;// CONCATENATED MODULE: ./src/components/page/RedirectingBackdrop/index.tsx




var RedirectingBackdrop = function(param) {
    var to = param.to;
    var isRedirecting = Boolean(to);
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Backdrop/* default */.Z, {
        open: isRedirecting,
        sx: function(param) {
            var palette = param.palette;
            return {
                zIndex: 2000,
                backgroundColor: "".concat(palette.common.white, " !important"),
                p: 3
            };
        },
        children: [
            to === "internal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {
                "data-testid": "overlay-loader"
            }),
            !!to && to !== "internal" && /*#__PURE__*/ (0,jsx_runtime.jsx)(Redirecting/* Redirecting */.F, {
                provider: to
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/components/ActivityCardRating/ActivityCardStarsRating.js + 1 modules
var ActivityCardStarsRating = __webpack_require__(85184);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/components/ActivityCardProviders/ViatorProviderTag.js
var ViatorProviderTag = __webpack_require__(51055);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/helpers/index.tsx



var setFilterURL = function(filterVals, isNationalListPage, seoSegmentId) {
    if (Object.hasOwn(filterVals, "subcategories")) {
        var newSegment = filterVals.subcategories.replaceAll(" ", "-").toLowerCase();
        var newSegmentForLocal = seoSegmentId.replace(/\/d\/[^/]+/, "/d/".concat(newSegment));
        return isNationalListPage ? "/explore/d/".concat(newSegment) : newSegmentForLocal;
    }
    if (Object.hasOwn(filterVals, "categories")) {
        var newSegment1 = filterVals.categories.replaceAll(" ", "-").toLowerCase();
        var newSegmentForLocal1 = seoSegmentId.replace(/\/d\/[^/]+/, "/d/".concat(newSegment1));
        return isNationalListPage ? "/explore/d/".concat(newSegment1) : newSegmentForLocal1;
    }
    return null;
};
/**
 * Takes an SEOSegmentationActivity and return a value that can be used as rating prop
 * When an activity is external and has rating the five star rating will be shown
 * Otherwise the default galore percentage rating is shown
 * @param activity SEOSegmentationActivity
 * @returns rating prop for the ActivityCard
 */ var getActivityCardRating = function(activity) {
    var ref, ref1, ref2;
    var ref3;
    var ref4 = (ref3 = (ref = activity.externalVendor) === null || ref === void 0 ? void 0 : (ref1 = ref.info) === null || ref1 === void 0 ? void 0 : ref1.rating) !== null && ref3 !== void 0 ? ref3 : {}, totalReviews = ref4.totalReviews, avarageRating = ref4.avarageRating;
    if (avarageRating) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCardStarsRating/* ActivityCardStarsRating */.z, {
            // viator brand color which is not part of the care palette
            iconProps: {
                color: "rgb(69, 183, 137);"
            },
            rating: avarageRating,
            totalReviews: totalReviews !== null && totalReviews !== void 0 ? totalReviews : undefined
        });
    }
    var ref5;
    return (ref5 = (ref2 = activity.reviews) === null || ref2 === void 0 ? void 0 : ref2.positiveReviews) !== null && ref5 !== void 0 ? ref5 : 0;
};
/**
 * Takes an SEOSegmentationActivity and return a value that can be used as organizationName prop
 * When an activity is external and provided by Viator the custom viator tag is shown
 * Otherwise the default galore provider name is shown
 * @param activity SEOSegmentationActivity
 * @returns organizationName prop for the ActivityCard
 */ var getActivityCardProvider = function(activity) {
    var _externalVendor;
    var vendorName = ((_externalVendor = activity.externalVendor) !== null && _externalVendor !== void 0 ? _externalVendor : {}).vendorName;
    if (vendorName === globalTypes/* ExternalVendors.VIATOR */.UR.VIATOR) return /*#__PURE__*/ (0,jsx_runtime.jsx)(ViatorProviderTag/* ViatorProviderTag */.V, {});
    var _providerName;
    return (_providerName = activity.providerName) !== null && _providerName !== void 0 ? _providerName : "";
};
/**
 * Takes an SEOSegmentationActivity and return a value that can be used as imageUrls prop
 * When an activity is external and has some image the image will be shown
 * Otherwise the images provided by galore are shown
 * @param activity SEOSegmentationActivity
 * @returns imageUrls prop for the ActivityCard
 */ var getActivityCardImages = function(activity) {
    var ref;
    var ref1;
    var photoUrl = ((ref1 = (ref = activity.externalVendor) === null || ref === void 0 ? void 0 : ref.info) !== null && ref1 !== void 0 ? ref1 : {}).photoUrl;
    return photoUrl ? [
        photoUrl
    ] : activity.photos;
};
/**
 * Takes an SEOSegmentationActivity and return a value that can be used as a href prop
 * When an activity is external and has an url the activity card will navigate to this link when clicked
 * Otherwise the galore url is used
 * @param activity SEOSegmentationActivity
 * @returns linkProps.href prop for the ActivityCard
 */ var getActivityCardUrl = function(activity) {
    var ref;
    var ref1;
    var ref2 = (ref1 = (ref = activity.externalVendor) === null || ref === void 0 ? void 0 : ref.info) !== null && ref1 !== void 0 ? ref1 : {}, externalUrl = ref2.activityUrl;
    if (externalUrl) return externalUrl;
    if (!activity.url) return undefined;
    return activity.url;
};

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ActivitiesCardListItem.tsx









var BadgeToComponent = {
    IN_PERSON: tags/* InPersonActivityTag */.LU,
    ONLINE: tags/* OnlineActivityTag */.i7
};
var redirectThroughBusinessSearch = function(provider, url) {
    var redirectParams = new URLSearchParams({
        provider: provider.toLowerCase(),
        to: url
    });
    window.open("/app/business-search/redirect?".concat(redirectParams.toString()), "_blank", "noopener,noreferrer");
};
var ActivityCardListItem = function(param) {
    var activity = param.activity, activityDetails = param.activityDetails;
    var ref, ref1, ref2, ref3, ref4, ref5, ref6, ref7, ref8, ref9, ref10, ref11, ref12;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var ref13 = (0,react.useState)(null), redirectingTo = ref13[0], setRedirectingTo = ref13[1];
    var getTags = function() {
        var tags = [];
        if (activity.participationType) {
            var BadgeComponent = BadgeToComponent[activity.participationType];
            tags.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(BadgeComponent, {}));
        }
        var ageText = activityAgesToRangeText(activity.minAgeMonths, activity.maxAgeMonths);
        if (ageText) {
            tags.push(/*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCardBadge/* ActivityCardBadge */.I, {
                variant: "tag",
                text: ageText
            }));
        }
        return tags;
    };
    var currentPrice = Number((ref = activity.discount) === null || ref === void 0 ? void 0 : (ref1 = ref.price) === null || ref1 === void 0 ? void 0 : ref1.amount) > 0 ? Number((ref2 = activity.discount) === null || ref2 === void 0 ? void 0 : (ref3 = ref2.price) === null || ref3 === void 0 ? void 0 : ref3.amount) : Number((ref4 = activity.price) === null || ref4 === void 0 ? void 0 : ref4.amount);
    var previousPrice = Number((ref5 = activity.discount) === null || ref5 === void 0 ? void 0 : (ref6 = ref5.price) === null || ref6 === void 0 ? void 0 : ref6.amount) > 0 ? Number((ref7 = activity.price) === null || ref7 === void 0 ? void 0 : ref7.amount) : Number((ref8 = activity.discount) === null || ref8 === void 0 ? void 0 : (ref9 = ref8.price) === null || ref9 === void 0 ? void 0 : ref9.amount);
    var getDiscount = function() {
        var ref, ref1;
        if (!((ref = activity.discount) === null || ref === void 0 ? void 0 : ref.description)) return null;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCardBadge/* ActivityCardBadge */.I, {
            text: (ref1 = activity.discount) === null || ref1 === void 0 ? void 0 : ref1.description
        });
    };
    var handleLinkClick = function(e) {
        var ref, ref1, ref2;
        var provider = (ref = activity.externalVendor) === null || ref === void 0 ? void 0 : ref.vendorName;
        var ref3;
        var externalUrl = (ref3 = (ref1 = activity.externalVendor) === null || ref1 === void 0 ? void 0 : (ref2 = ref1.info) === null || ref2 === void 0 ? void 0 : ref2.activityUrl) !== null && ref3 !== void 0 ? ref3 : null;
        var hasExternalUrl = externalUrl && provider;
        if (isSmallViewport) {
            setRedirectingTo(hasExternalUrl ? provider : "internal");
        }
        if (hasExternalUrl && !isSmallViewport) {
            e.preventDefault();
            var ref4;
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.viatorCardClick */.Sj.viatorCardClick, {
                feature_name: "Viator Activity Clicked",
                url: globalThis.location.href,
                url_path: globalThis.location.pathname,
                viator_url: externalUrl,
                viatorActivityPrice: currentPrice,
                seo_page_type: "C&A SEO page",
                page_template: activityDetails.pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL ? "National" : "Local",
                seo_page_title: (ref4 = activityDetails === null || activityDetails === void 0 ? void 0 : activityDetails.headline) !== null && ref4 !== void 0 ? ref4 : "",
                service_id_for_member: "".concat(activityDetails === null || activityDetails === void 0 ? void 0 : activityDetails.serviceIdForMember, "Activity")
            });
            redirectThroughBusinessSearch(provider, externalUrl);
        }
    };
    var onReadMoreClick = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "Read More Description"
        });
    };
    var _description, ref14;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard/* ActivityCard */.U, {
                badge: getDiscount(),
                title: activity.title,
                imageUrls: getActivityCardImages(activity),
                organizatorName: getActivityCardProvider(activity),
                description: (_description = activity.description) !== null && _description !== void 0 ? _description : "",
                price: currentPrice === 0 ? undefined : currentPrice,
                statusText: currentPrice === 0 ? "Check price" : undefined,
                statusTextSx: function(param) {
                    var palette = param.palette;
                    return {
                        textDecoration: "underline",
                        fontWeight: 400,
                        color: palette.text.tertiary
                    };
                },
                prevPrice: previousPrice && !((ref10 = activity.discount) === null || ref10 === void 0 ? void 0 : (ref11 = ref10.description) === null || ref11 === void 0 ? void 0 : ref11.toLowerCase().includes("sibling")) ? previousPrice : undefined,
                tags: getTags(),
                rating: getActivityCardRating(activity),
                locationName: (ref14 = (ref12 = activity.address) === null || ref12 === void 0 ? void 0 : ref12.cityState) !== null && ref14 !== void 0 ? ref14 : "",
                linkProps: {
                    href: getActivityCardUrl(activity),
                    target: isSmallViewport ? "" : "_blank",
                    onClick: handleLinkClick
                },
                hideFavoriteIcon: true,
                onReadMoreClick: onReadMoreClick
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(RedirectingBackdrop, {
                to: redirectingTo
            })
        ]
    });
};

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ActivitiesList.tsx




var ActivityGrid = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
        container: true,
        columnSpacing: 3,
        mb: 4,
        rowSpacing: 4,
        sx: {
            position: "relative"
        },
        children: children
    });
};
var ActivitiesList = function(param) {
    var activityDetails = param.activityDetails, searchResult = param.searchResult, isLoading = param.isLoading;
    var skeleton = new Array(21).fill(null).map(function() {
        return {
            id: (0,v4/* default */.Z)()
        };
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityGrid, {
        children: isLoading ? skeleton.map(function(param) {
            var id = param.id;
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                "data-testid": "card-loader",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
                    variant: "rounded",
                    width: 315,
                    height: 353
                })
            }, "card-loader-".concat(id));
        }) : searchResult.map(function(activity) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                item: true,
                xs: 12,
                sm: 6,
                md: 4,
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCardListItem, {
                    activityDetails: activityDetails,
                    activity: activity.seoSegmentationActivity
                })
            }, (0,v4/* default */.Z)());
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/Filter/components/FilterSelect/FilterSelect.js + 3 modules
var FilterSelect = __webpack_require__(59505);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/shared/FilterLayout.tsx



var Divider = /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
    sx: {
        width: "1px",
        backgroundColor: "default.light",
        height: "auto",
        my: 1.5
    }
});
var FilterLayout = function(param) {
    var LocationInput = param.LocationInput, children = param.children;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: function(theme) {
            return {
                display: "flex",
                flexDirection: "row",
                position: "sticky",
                top: {
                    xs: 56,
                    sm: 0
                },
                zIndex: 15,
                width: "100%",
                backgroundColor: theme.palette.background.default,
                paddingInline: theme.spacing(5),
                paddingBlock: theme.spacing(2),
                borderBottom: "1px solid ".concat(theme.palette.care.grey[300]),
                borderTop: "1px solid ".concat(theme.palette.care.grey[300]),
                px: {
                    xs: 2,
                    sm: 0
                }
            };
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
            maxWidth: "xl",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                sx: {
                    display: "flex",
                    flexDirection: {
                        xs: "column",
                        sm: "row"
                    },
                    gap: 2,
                    overflow: "scroll",
                    msOverflowStyle: "none",
                    scrollbarWidth: "none",
                    "&::-webkit-scrollbar": {
                        display: "none"
                    }
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        divider: {
                            xs: null,
                            sm: Divider
                        },
                        direction: {
                            xs: "column",
                            sm: "row"
                        },
                        gap: {
                            xs: 1,
                            sm: 2
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                            sx: {
                                width: {
                                    xs: "100%",
                                    sm: 230
                                }
                            },
                            children: LocationInput
                        })
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Stack/* default */.Z, {
                        direction: "row",
                        gap: 1,
                        sx: {
                            overflow: "scroll",
                            msOverflowStyle: "none",
                            scrollbarWidth: "none",
                            "&::-webkit-scrollbar": {
                                display: "none"
                            }
                        },
                        children: react.Children.map(children, function(filterSelectChild) {
                            return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    flexShrink: 0
                                },
                                children: filterSelectChild
                            });
                        })
                    })
                ]
            })
        })
    });
};

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/hooks/useActiveTheme.js
var useActiveTheme = __webpack_require__(56721);
// EXTERNAL MODULE: ./node_modules/@care/react-embrace-icons/dist/Icon24Camp.js
var Icon24Camp = __webpack_require__(67729);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/Filter/components/FilterPill/FilterPill.js
var FilterPill = __webpack_require__(65717);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoCamp.js
var Icon24InfoCamp = __webpack_require__(20660);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/shared/CampsFilter.tsx






var camp = constants/* FilterFieldNames.camp */.d8.camp;
var CampsFilter = function(param) {
    var defaultValue = param.defaultValue, onChange = param.onChange;
    var isEmbraceTheme = (0,useActiveTheme/* default */.Z)().isEmbraceTheme;
    var CampIcon = isEmbraceTheme ? Icon24Camp/* default */.Z : Icon24InfoCamp/* default */.Z;
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterPill/* FilterPill */.B, {
        name: camp,
        label: "Camps",
        defaultValue: defaultValue,
        icon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CampIcon, {}),
        iconPosition: "left",
        modalProps: {
            hideInModal: false,
            label: "Booking type"
        },
        onChange: onChange
    });
};

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/shared/Filters.tsx













var MultiSelect = function(props) {
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSelect/* FilterSelect */.z, (0,_object_spread/* default */.Z)({
        type: "multi-select",
        triggerSx: {
            maxWidth: 250
        }
    }, props));
};
var getCategoryKey = function(category) {
    // Convert camelCase to snake_case and then to lowercase
    var snakeCaseCategory = category.replace(/([a-z])([A-Z])/g, "$1_$2").toLowerCase().replace(/ /g, "_");
    var _snakeCaseCategory;
    return (_snakeCaseCategory = constants/* ACTIVITY_CATEGORY_TO_KEY */.kq[snakeCaseCategory]) !== null && _snakeCaseCategory !== void 0 ? _snakeCaseCategory : "";
};
var toTitleCase = function(str) {
    var acronyms = [
        "DJ",
        "3D"
    ];
    var titleCased = str.replace(/\w\S*/g, function(text) {
        return text.charAt(0).toUpperCase() + text.substring(1).toLowerCase();
    });
    return titleCased.split(" ").map(function(word) {
        if (acronyms.includes(word.toUpperCase())) {
            return word.toUpperCase();
        }
        return word;
    }).join(" ");
};
var getSubcategories = function(categoryKey) {
    var ref;
    var ref1;
    var subcategoryMetadata = (ref1 = (ref = constants/* ACTIVITY_CATEGORY_METADATA */.Ze[categoryKey]) === null || ref === void 0 ? void 0 : ref.subcategories) !== null && ref1 !== void 0 ? ref1 : Object.values(constants/* ACTIVITY_CATEGORY_METADATA */.Ze).flatMap(function(category) {
        return category.subcategories;
    });
    return subcategoryMetadata.map(function(subcategory) {
        return toTitleCase(subcategory.name);
    }).sort(function(a, b) {
        return a.localeCompare(b);
    });
};
var ExploreFilters = function(param) {
    var isMobile = param.isMobile, LocationInput = param.LocationInput, activityCategory = param.activityCategory, activitySubcategory = param.activitySubcategory;
    var ref;
    var ref1 = (0,SegmentationFiltersContext/* useSegmentationFiltersContext */.RZ)(), filters = ref1.filters, setFilters = ref1.setFilters, fetchResults = ref1.fetchResults;
    var filterByCampsFlag = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.OHPN_FILTER_BY_CAMPS.id */.WV.OHPN_FILTER_BY_CAMPS.id);
    var isFilterByCampsFlagEnabled = Boolean(filterByCampsFlag === null || filterByCampsFlag === void 0 ? void 0 : filterByCampsFlag.value);
    var isCookingCategoryFlagEnabled = ((ref = (0,useFeatureFlag/* default */.Z)(constants/* UI_FEATURE_FLAGS.OOH_ACTIVITIES_COOKING_CATEGORY.id */.WV.OOH_ACTIVITIES_COOKING_CATEGORY.id)) === null || ref === void 0 ? void 0 : ref.variationIndex) === 0;
    var categoryKey = getCategoryKey(activityCategory);
    var defaultCategory = constants/* ACTIVITY_CATEGORY_TITLES */._f[categoryKey];
    var categoryOptions = Object.entries(constants/* ACTIVITY_CATEGORY_TITLES */._f).filter(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 1), key = _param[0];
        return isCookingCategoryFlagEnabled || key !== "COOKING";
    }).map(function(param) {
        var _param = (0,_sliced_to_array/* default */.Z)(param, 2), value = _param[1];
        return value;
    }).sort(function(a, b) {
        return a.localeCompare(b);
    });
    var initialSubcategoryOptions = getSubcategories(categoryKey);
    var ref2 = (0,react.useState)(initialSubcategoryOptions), subcategoryOptions = ref2[0], setSubcategoryOptions = ref2[1];
    var applyFilters = function(nextFilters) {
        var _ref = filters !== null && filters !== void 0 ? filters : {}, typename = _ref.__typename, location = _ref.location, restFilters = (0,_object_without_properties/* default */.Z)(_ref, [
            "__typename",
            "location"
        ]);
        var ref;
        var zipcode = (ref = location === null || location === void 0 ? void 0 : location.zipcode) !== null && ref !== void 0 ? ref : undefined;
        var updatedFilters = (0,_object_spread/* default */.Z)({
            zipcode: zipcode
        }, restFilters, nextFilters);
        (0,filtersStorage/* saveFilters */.HJ)(updatedFilters);
        setFilters(updatedFilters);
        fetchResults(updatedFilters, true);
    };
    var onApplyActivityType = function(selectedActivityType) {
        if (!selectedActivityType) return;
        var activityParticipationType = selectedActivityType.map(function(type) {
            return constants/* ACTIVITY_MAP_TO_FILTER */.H6[type];
        });
        applyFilters({
            activityParticipationType: activityParticipationType
        });
    };
    var onApplyDays = function(selectedDays) {
        if (!selectedDays || isMobile) return;
        var activityDaysOfWeek = selectedDays.map(function(day) {
            return constants/* DAYS_MAP_TO_FILTER */.Aq[day];
        });
        applyFilters({
            activityDaysOfWeek: activityDaysOfWeek
        });
    };
    var onApplyAges = function(selectedAges) {
        if (!selectedAges || isMobile) return;
        var childCareAgeGroups = selectedAges.map(function(age) {
            return constants/* AGES_MAP_TO_FILTER */.ld[age];
        });
        applyFilters({
            childCareAgeGroups: childCareAgeGroups
        });
    };
    var onApplyDates = function(selectedDates) {
        if (isMobile) return;
        var dates = selectedDates ? selectedDates.map(function(dayJs) {
            return dayJs.format("YYYY-MM-DD");
        }) : [];
        applyFilters({
            activityDates: dates
        });
    };
    var onApplyCamps = function(onlyCampActivities) {
        applyFilters({
            onlyCampActivities: onlyCampActivities
        });
    };
    var onFilterOpen = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "Filter Viewed"
        });
    };
    var toTitleCaseWithSpace = function(str) {
        // Add a space before each uppercase letter and capitalize the first letter of each word
        return str.replace(/([a-z])([A-Z])/g, "$1 $2").replace(/\b\w/g, function(char) {
            return char.toUpperCase();
        });
    };
    var formattedSubcategory = toTitleCaseWithSpace(activitySubcategory !== null && activitySubcategory !== void 0 ? activitySubcategory : "");
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(FilterLayout, {
        LocationInput: LocationInput,
        children: [
            isFilterByCampsFlagEnabled && /*#__PURE__*/ (0,jsx_runtime.jsx)(CampsFilter, {
                onChange: onApplyCamps
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSelect/* FilterSelect */.z, {
                defaultValue: defaultCategory,
                label: "Categories",
                options: categoryOptions,
                type: "single-select",
                name: constants/* FilterFieldNames.categories */.d8.categories,
                onOpen: onFilterOpen,
                onChange: function(currentCategory) {
                    var currentActivityKey = getCategoryKey(currentCategory);
                    setSubcategoryOptions(getSubcategories(currentActivityKey));
                }
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSelect/* FilterSelect */.z, {
                defaultValue: formattedSubcategory,
                label: "Subcategories",
                name: constants/* FilterFieldNames.subcategories */.d8.subcategories,
                options: subcategoryOptions,
                type: "single-select",
                onOpen: onFilterOpen,
                disabled: categoryKey === "COOKING" || categoryKey === "ACTIVITIES"
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect, {
                label: "Ages",
                options: constants/* ages */.uP,
                name: constants/* FilterFieldNames.ages */.d8.ages,
                onOpen: onFilterOpen,
                onChange: onApplyAges
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterSelect/* FilterSelect */.z, {
                type: "dates",
                label: "Dates",
                name: constants/* FilterFieldNames.dates */.d8.dates,
                onOpen: onFilterOpen,
                onChange: onApplyDates
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect, {
                label: "Activity type",
                options: constants/* activityTypes */.JK,
                name: constants/* FilterFieldNames.activityType */.d8.activityType,
                onOpen: onFilterOpen,
                onChange: onApplyActivityType
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)(MultiSelect, {
                label: "Days",
                options: constants/* days */.an,
                name: constants/* FilterFieldNames.days */.d8.days,
                onOpen: onFilterOpen,
                onChange: onApplyDays
            })
        ]
    });
};

// EXTERNAL MODULE: ./node_modules/@care/react-svg-icons/dist/Icon104Telescope.js
var Icon104Telescope = __webpack_require__(41272);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ExploreNoResults.tsx






var ExploreNoResults = function(param) {
    var noResults = param.noResults, isMobileOrSmaller = param.isMobileOrSmaller, isNationalListPage = param.isNationalListPage;
    var ref = (0,PageAttributesContext/* usePageAttributes */.l)(), segmentNamePluralLowerCase = ref.segmentNamePluralLowerCase, city = ref.city, state = ref.state;
    var availableText = isNationalListPage ? "There are no ".concat(segmentNamePluralLowerCase, " available in your area") : "There are no ".concat(segmentNamePluralLowerCase, " available in ").concat(city, ", ").concat(state);
    var headlineText = noResults ? "No matches within your search" : availableText;
    var bodyText = noResults ? "Sorry, we couldn’t find a good match. Try adjusting your filters or browsing other activity options." : "Try searching again in the nearest city";
    var onClick = function(event) {
        event.preventDefault();
        var url = isNationalListPage ? "/explore/d/activities" : globalThis.location.pathname.replace(/(\/explore\/d\/)[^/]+/, "$1activities");
        globalThis.location.href = url;
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            feature_name: "Explore other activities CTA"
        });
    };
    (0,react.useEffect)(function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.errorViewed */.Sj.errorViewed, {
            error_description: "SEO no results"
        });
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
        sx: {
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            pb: 6
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            sx: {
                maxWidth: 392,
                textAlign: "center"
            },
            alignItems: "center",
            gap: 2,
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon104Telescope/* default */.Z, {
                    size: 200
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Typography/* default */.Z, {
                    variant: "h1",
                    children: [
                        " ",
                        headlineText
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                    variant: "body1",
                    children: bodyText
                }),
                noResults && /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
                    fullWidth: isMobileOrSmaller,
                    color: "secondary",
                    component: "a",
                    href: "",
                    onClick: onClick,
                    size: "large",
                    sx: {
                        minWidth: isMobileOrSmaller ? "auto" : "280px",
                        mt: isMobileOrSmaller ? 18 : 0
                    },
                    variant: "contained",
                    children: "Explore other activities"
                })
            ]
        })
    });
};
/* harmony default export */ var campsAndActivities_ExploreNoResults = (ExploreNoResults);

// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/InlineTextField/InlineTextField.js
var InlineTextField = __webpack_require__(99842);
// EXTERNAL MODULE: ./node_modules/@mui/material/InputAdornment/InputAdornment.js + 1 modules
var InputAdornment = __webpack_require__(87109);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoLocation.js
var Icon24InfoLocation = __webpack_require__(59242);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/shared/ExploreLocationSearch.tsx








var ExploreLocationSearch = function(param) {
    var address = param.address, isLoading = param.isLoading, onChange = param.onChange;
    var prePopulatedZip = !(address === null || address === void 0 ? void 0 : address.city) || !address.state ? address === null || address === void 0 ? void 0 : address.zipcode : "".concat(address.city, ", ").concat(address.state);
    if (isLoading) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Skeleton/* default */.Z, {
            "data-testid": "explore-location-search-loader",
            variant: "rounded",
            sx: {
                borderRadius: "12px",
                width: "100%",
                height: "100%"
            }
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(GoogleMaps/* default.ZipCodeAddressSearchViewAutoComplete */.Z.ZipCodeAddressSearchViewAutoComplete, {
        searchByCityOrState: true,
        blurOnSelect: true,
        setCareLocation: function() {},
        setSeekerAddress: onChange,
        setShowAppSuite: function() {},
        initialValue: prePopulatedZip,
        renderInput: function(params) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(InlineTextField/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, params), {
                placeholder: "City, State, Address or ZIP code",
                label: "Location",
                InputLabelProps: {
                    sx: {
                        display: "none"
                    }
                },
                value: prePopulatedZip,
                id: "location-search",
                InputProps: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    sx: {
                        p: 0
                    }
                }, params.InputProps), {
                    endAdornment: /*#__PURE__*/ (0,jsx_runtime.jsx)(InputAdornment/* default */.Z, {
                        position: "end",
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoLocation/* default */.Z, {})
                    })
                })
            }));
        }
    });
};
/* harmony default export */ var shared_ExploreLocationSearch = (ExploreLocationSearch);

// EXTERNAL MODULE: ./node_modules/@react-google-maps/api/dist/esm.js
var esm = __webpack_require__(37054);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ActivitiesMap/ActivitiesMarker.tsx
/* eslint-disable complexity */ 







var ActivitiesMarker = function(param) {
    var activity = param.activity, id = param.id, setSelectedMarkerId = param.setSelectedMarkerId, slotProps = param.slotProps;
    var ref, ref1, ref2, ref3;
    var isSmallViewport = (0,useResponsive/* useResponsive */.F)().isSmallViewport;
    var ref4 = (0,react.useState)(false), selectedMarker = ref4[0], setSelectedMarker = ref4[1];
    var ref5 = (0,react.useState)(null), timeoutId = ref5[0], setTimeoutId = ref5[1];
    var title = activity.title, discount = activity.discount, price = activity.price, address = activity.address;
    var url = getActivityCardUrl(activity);
    var ref6 = address !== null && address !== void 0 ? address : {}, latitude = ref6.latitude, longitude = ref6.longitude;
    var currentPrice = Number(discount === null || discount === void 0 ? void 0 : (ref = discount.price) === null || ref === void 0 ? void 0 : ref.amount) > 0 ? Number(discount === null || discount === void 0 ? void 0 : (ref1 = discount.price) === null || ref1 === void 0 ? void 0 : ref1.amount) : Number(price === null || price === void 0 ? void 0 : price.amount);
    var previousPrice = Number(discount === null || discount === void 0 ? void 0 : (ref2 = discount.price) === null || ref2 === void 0 ? void 0 : ref2.amount) > 0 ? Number(price === null || price === void 0 ? void 0 : price.amount) : Number(discount === null || discount === void 0 ? void 0 : (ref3 = discount.price) === null || ref3 === void 0 ? void 0 : ref3.amount);
    var handleMouseOver = function() {
        if (timeoutId) {
            clearTimeout(timeoutId);
            setTimeoutId(null);
        }
        setSelectedMarker(true);
    };
    var handleMouseOut = function() {
        setTimeoutId(setTimeout(function() {
            setSelectedMarker(false);
        }, 500));
    };
    // specific to mobile viewports to render info card on click
    var handleMouseClick = function() {
        setSelectedMarkerId(id);
    };
    var markerPropsMobile = {
        onClick: handleMouseClick
    };
    var markerPropsTabletOrDesktop = {
        onClick: handleMouseOver,
        onMouseOver: handleMouseOver,
        onMouseOut: handleMouseOut
    };
    var additionalMarkerProps = isSmallViewport ? markerPropsMobile : markerPropsTabletOrDesktop;
    return latitude && longitude ? /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* Marker */.Jx, (0,_object_spread/* default */.Z)({
                position: {
                    lat: latitude,
                    lng: longitude
                },
                title: title
            }, additionalMarkerProps, slotProps)),
            !isSmallViewport && selectedMarker && /*#__PURE__*/ (0,jsx_runtime.jsx)(esm/* InfoWindow */.nx, {
                position: {
                    lat: latitude,
                    lng: longitude
                },
                onCloseClick: function() {
                    return setSelectedMarker(false);
                },
                options: {
                    ariaLabel: title
                },
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                    overflow: "hidden",
                    onMouseOver: handleMouseOver,
                    onMouseOut: handleMouseOut,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCard/* ActivityCard */.U, (0,_object_spread/* default */.Z)({
                        title: title,
                        prevPrice: previousPrice || undefined,
                        price: currentPrice === 0 ? undefined : currentPrice,
                        organizatorName: getActivityCardProvider(activity),
                        rating: getActivityCardRating(activity),
                        imageUrls: getActivityCardImages(activity),
                        description: "",
                        statusText: currentPrice === 0 ? "Check price" : undefined,
                        statusTextSx: function(param) {
                            var palette = param.palette;
                            return {
                                textDecoration: "underline",
                                fontWeight: 400,
                                color: palette.text.tertiary
                            };
                        },
                        hideFavoriteIcon: true
                    }, url && {
                        linkProps: {
                            href: url,
                            target: "_blank"
                        }
                    }))
                })
            })
        ]
    }) : null;
};


// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/components/ActivityCardRating/ActivityCardRating.js + 1 modules
var ActivityCardRating = __webpack_require__(82894);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/components/ActivityCardMedia/ActivityCardMapMedia.js
var ActivityCardMapMedia = __webpack_require__(18930);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/components/ActivityCardHeader.js + 1 modules
var ActivityCardHeader = __webpack_require__(55282);
// EXTERNAL MODULE: ./node_modules/@care/provider-react-components/dist/components/ActivityCard/components/ActivityCardPrice.js
var ActivityCardPrice = __webpack_require__(85056);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ActivitiesMap/ActivitiesInfoCardMobile.tsx






var ActivitiesInfoCardMobile = function(param) {
    var activity = param.activity, _prevPrice = param.prevPrice, prevPrice = _prevPrice === void 0 ? undefined : _prevPrice, price = param.price, slotProps = param.slotProps;
    var url = getActivityCardUrl(activity);
    var renderCard = function() {
        var rating = getActivityCardRating(activity);
        var internalRating = typeof rating === "number";
        var InternalRatingElement = internalRating && rating > 0 ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCardRating/* ActivityCardRating */.A, {
            rating: rating
        }) : null;
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
            direction: "row",
            sx: {
                width: "90%",
                overflow: "hidden",
                backgroundColor: "background.default",
                borderRadius: 4,
                position: "absolute",
                bottom: 70,
                left: "50%",
                transform: "translateX(-50%)"
            },
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCardMapMedia/* ActivityCardMapMedia */.B, {
                    imageUrl: getActivityCardImages(activity)[0],
                    sx: {
                        backgroundColor: "background.default"
                    }
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                    direction: "column",
                    flex: 1,
                    p: 2,
                    zIndex: 110,
                    sx: {
                        backgroundColor: "background.default"
                    },
                    children: [
                        /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCardHeader/* ActivityCardHeader */.k, {
                            title: activity.title,
                            variant: "map",
                            organizatorName: getActivityCardProvider(activity)
                        }),
                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Stack/* default */.Z, {
                            mt: 2.5,
                            direction: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            children: [
                                /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivityCardPrice/* ActivityCardPrice */.J, {
                                    price: price === 0 ? undefined : price,
                                    prevPrice: prevPrice || undefined,
                                    statusText: price === 0 ? "Check price" : undefined,
                                    statusTextSx: function(param) {
                                        var palette = param.palette;
                                        return {
                                            textDecoration: "underline",
                                            fontWeight: 400,
                                            color: palette.text.tertiary
                                        };
                                    }
                                }),
                                internalRating ? InternalRatingElement : rating
                            ]
                        })
                    ]
                })
            ]
        });
    };
    return url ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Link/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        href: url,
        underline: "none",
        variant: "link2",
        color: "care.black"
    }, slotProps), {
        children: renderCard()
    })) : /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slotProps), {
        children: renderCard()
    }));
};


;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ActivitiesMap/ActivitiesMap.tsx












var publicRuntimeConfig = config_default()().publicRuntimeConfig;
var ActivitiesMap = function(param) {
    var activitiesSearchResults = param.activitiesSearchResults, userGeoInfo = param.userGeoInfo, slotProps = param.slotProps, location = param.location;
    var isLoaded = (0,esm/* useJsApiLoader */.Ji)({
        googleMapsApiKey: publicRuntimeConfig.GOOGLE_MAPS_KEY
    }).isLoaded;
    var ref = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref.isSmallViewport, isMediumViewport = ref.isMediumViewport;
    var ref1 = (0,react.useState)(null), currentMap = ref1[0], setCurrentMap = ref1[1];
    var ref2 = (0,react.useState)(undefined), centerPoint = ref2[0], setCenterPoint = ref2[1];
    var ref3 = (0,react.useState)("840px"), mapHeight = ref3[0], setMapHeight = ref3[1];
    var ref4 = (0,react.useState)(null), selectedMarkerId = ref4[0], setSelectedMarkerId = ref4[1];
    var activitiesList = activitiesSearchResults.map(function(activity, idx) {
        return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, activity.seoSegmentationActivity), {
            id: idx + 1
        });
    });
    var validLocations = (0,react.useMemo)(function() {
        return activitiesSearchResults.map(function(activity) {
            return activity.seoSegmentationActivity.address;
        }).filter(function(address) {
            return Number.isFinite(address === null || address === void 0 ? void 0 : address.latitude) && (address === null || address === void 0 ? void 0 : address.latitude) !== 0 && Number.isFinite(address === null || address === void 0 ? void 0 : address.longitude) && (address === null || address === void 0 ? void 0 : address.longitude) !== 0;
        });
    }, [
        activitiesSearchResults
    ]);
    var defaultMapZoom = validLocations.length > 0 ? 15 : 10;
    (0,react.useEffect)(function() {
        var updateMapHeight = function() {
            if (isSmallViewport) {
                // hacky solution since the map won't render without a defined height value.
                // Subtract filters height and navbar height from total viewport height
                setMapHeight("calc(100vh - 148px - 56px)");
            } else if (isMediumViewport) {
                setMapHeight("600px");
            } else {
                setMapHeight("840px");
            }
        };
        updateMapHeight();
    }, [
        isSmallViewport,
        isMediumViewport
    ]);
    (0,react.useEffect)(function() {
        if (!isLoaded) {
            return;
        }
        var getUserGeoLatLng = function(geoInfo) {
            var userLatLng = {
                lat: 0,
                lng: 0
            };
            geoInfo.split(",").forEach(function(info) {
                var ref = (0,_sliced_to_array/* default */.Z)(info.split("="), 2), key = ref[0], value = ref[1];
                if (key === "lat") {
                    userLatLng.lat = parseFloat(value) || 0;
                } else if (key === "long") {
                    userLatLng.lng = parseFloat(value) || 0;
                }
            });
            return userLatLng;
        };
        var userGeoLatLng = getUserGeoLatLng(userGeoInfo);
        var latCenterPoint = validLocations.reduce(function(sum, address) {
            return sum + ((address === null || address === void 0 ? void 0 : address.latitude) || 0);
        }, 0) / validLocations.length || 0;
        var lngCenterPoint = validLocations.reduce(function(sum, address) {
            return sum + ((address === null || address === void 0 ? void 0 : address.longitude) || 0);
        }, 0) / validLocations.length || 0;
        // set center point to the average of all valid locations if available
        if (validLocations.length > 0 && latCenterPoint !== 0 && lngCenterPoint !== 0) {
            setCenterPoint({
                lat: latCenterPoint,
                lng: lngCenterPoint
            });
        } else if (validLocations.length === 0 || latCenterPoint === 0 && lngCenterPoint === 0 && (location === null || location === void 0 ? void 0 : location.zipcode)) {
            setCenterPoint({
                lat: (location === null || location === void 0 ? void 0 : location.latitude) || userGeoLatLng.lat,
                lng: (location === null || location === void 0 ? void 0 : location.longitude) || userGeoLatLng.lng
            });
        }
    }, [
        isLoaded,
        activitiesSearchResults,
        userGeoInfo,
        location,
        validLocations
    ]);
    (0,react.useEffect)(function() {
        if (!isLoaded) {
            return;
        }
        // extend map bounds to fit all valid locations
        if (currentMap && validLocations.length > 0) {
            var bounds = new google.maps.LatLngBounds();
            validLocations.forEach(function(loc) {
                if (typeof (loc === null || loc === void 0 ? void 0 : loc.latitude) === "number" && typeof (loc === null || loc === void 0 ? void 0 : loc.longitude) === "number") {
                    bounds.extend({
                        lat: loc.latitude,
                        lng: loc.longitude
                    });
                }
            });
            currentMap.fitBounds(bounds);
        }
    }, [
        currentMap,
        isLoaded,
        validLocations
    ]);
    // render info card for mobile view
    var renderInfoCardMobile = function(markerId) {
        var ref, ref1, ref2, ref3;
        var activity = activitiesList.find(function(param) {
            var id = param.id;
            return id === markerId;
        });
        if (!isSmallViewport || !activity) {
            return null;
        }
        var discount = activity.discount, price = activity.price;
        var currentPrice = Number(discount === null || discount === void 0 ? void 0 : (ref = discount.price) === null || ref === void 0 ? void 0 : ref.amount) > 0 ? Number(discount === null || discount === void 0 ? void 0 : (ref1 = discount.price) === null || ref1 === void 0 ? void 0 : ref1.amount) : Number(price === null || price === void 0 ? void 0 : price.amount);
        var previousPrice = Number(discount === null || discount === void 0 ? void 0 : (ref2 = discount.price) === null || ref2 === void 0 ? void 0 : ref2.amount) > 0 ? Number(price === null || price === void 0 ? void 0 : price.amount) : Number(discount === null || discount === void 0 ? void 0 : (ref3 = discount.price) === null || ref3 === void 0 ? void 0 : ref3.amount);
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitiesInfoCardMobile, {
            activity: activity,
            prevPrice: previousPrice !== null && previousPrice !== void 0 ? previousPrice : undefined,
            price: currentPrice,
            slotProps: slotProps
        });
    };
    if (!isLoaded) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            width: "100%",
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Loader/* default */.Z, {})
        });
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, slotProps), {
        height: "100%",
        width: "100%",
        children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(esm/* GoogleMap */.b6, {
            id: "google-maps",
            onLoad: function(map) {
                return setCurrentMap(map);
            },
            options: {
                draggable: true,
                mapTypeControl: false,
                streetViewControl: false,
                fullscreenControl: false,
                zoomControl: false
            },
            center: centerPoint,
            zoom: defaultMapZoom,
            mapContainerStyle: {
                height: mapHeight,
                width: "auto"
            },
            children: [
                activitiesList.map(function(activity) {
                    return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitiesMarker, {
                            id: activity.id,
                            activity: activity,
                            setSelectedMarkerId: setSelectedMarkerId
                        })
                    }, activity.id);
                }),
                renderInfoCardMobile(selectedMarkerId)
            ]
        })
    }));
};


// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoErrands.js
var Icon24InfoErrands = __webpack_require__(17768);
// EXTERNAL MODULE: ./node_modules/@care/react-icons/dist/Icon24InfoMap.js
var Icon24InfoMap = __webpack_require__(10363);
// EXTERNAL MODULE: ./node_modules/@care/react-component-lib/dist/components/StickyContainer/StickyContainer.js
var StickyContainer = __webpack_require__(14721);
;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/ActivitiesMap/ActivitiesMapCTA.tsx





var ActivitiesMapCTA = function(param) {
    var showMap = param.showMap, setShowMap = param.setShowMap;
    var listView = {
        ctaText: "List view",
        ctaIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoErrands/* default */.Z, {})
    };
    var mapView = {
        ctaText: "Map",
        ctaIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(Icon24InfoMap/* default */.Z, {})
    };
    var cta = showMap ? listView : mapView;
    var handleCTAClick = function() {
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
            cta_text: showMap ? "List view" : "Map"
        });
        setShowMap(!showMap);
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(StickyContainer/* default */.Z, {
        className: showMap ? "show-map" : undefined,
        sx: {
            zIndex: 99,
            "&.show-map": {
                background: "none"
            }
        },
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Button/* default */.Z, {
            variant: "outlined",
            size: "small",
            color: "secondary",
            onClick: handleCTAClick,
            sx: {
                px: 2,
                minHeight: "40px",
                width: "auto"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Box/* default */.Z, {
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                        pr: 1,
                        pt: 1,
                        children: cta.ctaIcon
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        component: "span",
                        variant: "body1",
                        textAlign: "center",
                        children: cta.ctaText
                    })
                ]
            })
        })
    });
};


;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/CampsAndActivitiesListingPage.tsx
/* eslint-disable complexity */ 






































var CampsAndActivitiesListingPage = function(param) {
    var pageData = param.pageData, deviceChar = param.deviceChar, initialPageNumber = param.initialPageNumber, seoSegmentId = param.seoSegmentId, ipAddress = param.ipAddress, botInfo = param.botInfo, userGeoInfo = param.userGeoInfo, userAgent = param.userAgent, local = param.local, showProviderSignUpBanner = param.showProviderSignUpBanner;
    var ref;
    var ref1 = (0,react.useState)(seoSegmentId), segmentId = ref1[0], setSegmentId = ref1[1];
    var router = (0,next_router.useRouter)();
    var ref2 = (0,react.useState)(initialPageNumber), pageNumber = ref2[0], setPageNumber = ref2[1];
    var scrollToTopRef = (0,react.useRef)(null);
    var ref3 = (0,useResponsive/* useResponsive */.F)(), isSmallViewport = ref3.isSmallViewport, isLargeViewport = ref3.isLargeViewport, isMediumViewport = ref3.isMediumViewport;
    var _seoSegmentationSearchResults = pageData.seoSegmentationSearchResults, initialPagination = _seoSegmentationSearchResults.pagination, initialActivitySearchResults = _seoSegmentationSearchResults.activitySearchResults, initialFilters = _seoSegmentationSearchResults.filters, initialActivityDetails = pageData.seoSegmentationActivityDetails, initialFaqs = pageData.getSEOSegmentationFAQs, initialLinkSections = pageData.getSEOSegmentationLinkSections;
    var ref4 = (0,react.useState)(initialPagination), pagination = ref4[0], setPagination = ref4[1];
    var ref5 = (0,react.useState)(initialLinkSections), linkSections = ref5[0], setLinkSections = ref5[1];
    var ref6 = (0,react.useState)(initialFaqs), faqs = ref6[0], setFaqs = ref6[1];
    var ref7 = (0,react.useState)((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, initialFilters), {
        sortBy: globalTypes/* EventsSortBy.RECOMMENDED */.fC.RECOMMENDED
    })), filters = ref7[0], setFilters = ref7[1];
    var ref8 = (0,react.useState)(initialActivitySearchResults), activitySearchResults = ref8[0], setActivitySearchResults = ref8[1];
    var ref9 = (0,react.useState)(false), showMap = ref9[0], setShowMap = ref9[1];
    var stringifyDeviceChar = JSON.stringify(deviceChar);
    var ref10 = (0,react.useState)(initialActivityDetails), activityDetails = ref10[0], setActivityDetails = ref10[1];
    var seoPageMetadata = activityDetails.seoPageMetadata;
    var internalLinkingHeadline = "Additional ".concat(activityDetails.segmentNameSingular, " Services");
    var isNationalListPage = activityDetails.pageType === globalTypes/* SEOSegmentationPageType.NATIONAL */.a6.NATIONAL;
    var initialBreadcrumbs = pageData.seoSegmentationBreadcrumbs.__typename === "SEOSegmentationBreadcrumbsSuccess" ? pageData.seoSegmentationBreadcrumbs.breadcrumbs : null;
    var ref11 = (0,react.useState)(initialBreadcrumbs), breadcrumbs = ref11[0], setBreadcrumbs = ref11[1];
    var initialArticles = pageData.seoArticlesList.__typename === "SEOArticlesListSuccess" ? pageData.seoArticlesList.seoArticlesList : null;
    var ref12 = (0,react.useState)(initialArticles), articles = ref12[0], setArticles = ref12[1];
    var ref13 = (0,_sliced_to_array/* default */.Z)((0,useLazyQuery/* useLazyQuery */.t)(API_getActivitySearchResults, {
        variables: {
            filters: null,
            pageNumber: pageNumber,
            seoSegmentId: segmentId,
            ipAddress: ipAddress,
            botInfo: botInfo,
            userGeoInfo: userGeoInfo,
            userAgent: userAgent
        },
        onCompleted: function(data) {
            var searchResultData = data.seoSegmentationSearchResults.__typename === "SEOSegmentationSearchResultsSuccess" ? data.seoSegmentationSearchResults : null;
            var breadcrumbsData = data.seoSegmentationBreadcrumbs.__typename === "SEOSegmentationBreadcrumbsSuccess" ? data.seoSegmentationBreadcrumbs.breadcrumbs : null;
            var activityDetailsData = data.seoSegmentationActivityDetails.__typename === "SEOSegmentationActivityDetailsSuccess" ? data.seoSegmentationActivityDetails.segmentDetails : null;
            var articlesData = pageData.seoArticlesList.__typename === "SEOArticlesListSuccess" ? pageData.seoArticlesList.seoArticlesList : null;
            var faqsData = data.getSEOSegmentationFAQs;
            var linkSectionsData = data.getSEOSegmentationLinkSections;
            if (searchResultData) {
                var ref;
                setPagination(searchResultData.pagination);
                setActivitySearchResults(searchResultData.activitySearchResults);
                if (activityDetailsData) setActivityDetails(activityDetailsData);
                if (articlesData) setArticles(articlesData);
                if (faqsData) setFaqs(faqsData);
                if (linkSectionsData) setLinkSections(linkSectionsData);
                if (breadcrumbsData) setBreadcrumbs(breadcrumbsData);
                (ref = scrollToTopRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
            }
        }
    }), 2), getActivitySearchResults = ref13[0], ref14 = ref13[1], isLoading = ref14.loading;
    var handlePageClick = function(newPage) {
        var filterSelected = (0,filtersStorage/* loadFilters */.dm)() || {};
        if (filters) {
            if (filters.location) {
                filterSelected.zipcode = filters.location.zipcode;
            }
        }
        setPageNumber(newPage);
        getActivitySearchResults({
            variables: {
                filters: filterSelected,
                pageNumber: newPage,
                seoSegmentId: seoSegmentId,
                ipAddress: ipAddress,
                botInfo: botInfo,
                userGeoInfo: userGeoInfo,
                userAgent: userAgent
            }
        });
    };
    var locationTypes = (0,ZipCodeAddressSearchViewAutoComplete/* searchViewAutoCompleteProviderRequestOptions */.j)(false, true);
    var estimatedZipcode = function() {
        return (0,getZipcodeFromGeoInfo/* getZipcodeFromGeoInfo */.Z)(userGeoInfo);
    };
    var ref15;
    var ref16 = (0,react.useState)({
        latitude: null,
        longitude: null,
        zipcode: (ref15 = filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode) !== null && ref15 !== void 0 ? ref15 : estimatedZipcode()
    }), location = ref16[0], setLocationState = ref16[1];
    var setLocation = (0,react.useCallback)(function(address) {
        var ref;
        if (address.zip) {
            setFilters(function(prevFilters) {
                return (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, prevFilters), {
                    location: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (prevFilters === null || prevFilters === void 0 ? void 0 : prevFilters.location) || {}), {
                        zipcode: address.zip
                    })
                });
            });
        }
        setLocationState({
            zipcode: address.zip,
            longitude: address.longitude,
            latitude: address.latitude
        });
        setPageNumber(1);
        getActivitySearchResults({
            variables: {
                filters: {
                    zipcode: address.zip
                },
                pageNumber: 1,
                seoSegmentId: segmentId,
                ipAddress: ipAddress,
                botInfo: botInfo,
                userGeoInfo: userGeoInfo,
                userAgent: userAgent
            }
        });
        if (!isNationalListPage) {
            router.push(seoSegmentId.replace(/\/[^/]+$/, "/"), undefined, {
                shallow: false
            });
        }
        (ref = scrollToTopRef.current) === null || ref === void 0 ? void 0 : ref.scrollIntoView();
    }, [
        botInfo,
        getActivitySearchResults,
        ipAddress,
        seoSegmentId,
        userAgent,
        userGeoInfo,
        router,
        isNationalListPage,
        segmentId, 
    ]);
    var onFilterChange = function(filterVals) {
        var ref;
        var url = setFilterURL(filterVals, isNationalListPage, seoSegmentId);
        if (!url || globalThis.location.pathname === url) return;
        var categories = filterVals.categories, subcategories = filterVals.subcategories, otherFilterVals = (0,_object_without_properties/* default */.Z)(filterVals, [
            "categories",
            "subcategories"
        ]);
        var filterSelected = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, otherFilterVals), {
            zipcode: filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode
        });
        router.push(url, undefined, {
            shallow: true
        });
        setSegmentId(url);
        setPageNumber(1);
        getActivitySearchResults({
            variables: {
                filters: filterSelected,
                pageNumber: 1,
                seoSegmentId: url,
                ipAddress: ipAddress,
                botInfo: botInfo,
                userGeoInfo: userGeoInfo,
                userAgent: userAgent
            }
        });
    };
    var filtersCtx = (0,react.useMemo)(function() {
        return {
            filters: filters,
            setFilters: function(filterVals, reset) {
                setFilters(reset ? filterVals : function(prevFilters) {
                    return (0,_object_spread/* default */.Z)({}, prevFilters, filterVals);
                });
            },
            fetchResults: function(filterVals, resetPage) {
                var ref;
                var updatedFilterVals = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, filterVals), {
                    zipcode: filters === null || filters === void 0 ? void 0 : (ref = filters.location) === null || ref === void 0 ? void 0 : ref.zipcode
                });
                getActivitySearchResults({
                    variables: {
                        filters: updatedFilterVals,
                        pageNumber: resetPage ? 1 : pageNumber,
                        seoSegmentId: segmentId,
                        ipAddress: ipAddress,
                        botInfo: botInfo,
                        userGeoInfo: userGeoInfo,
                        userAgent: userAgent
                    }
                });
            }
        };
    }, [
        getActivitySearchResults,
        filters,
        pageNumber,
        segmentId,
        ipAddress,
        botInfo,
        userGeoInfo,
        userAgent, 
    ]);
    var validateHeaderData = function(data) {
        return {
            device_os: data.device_os || "unknown",
            is_mobile: data.is_mobile || "false",
            mobile_browser_version: data.mobile_browser_version || "0.0",
            mobile_browser: data.mobile_browser || "unknown"
        };
    };
    (0,react.useEffect)(function() {
        var pageProperties = {
            screen_name: constants/* ScreenName.SEGMENTATION */.CG.SEGMENTATION,
            screen_template: constants/* ScreenTemplate.SEGMENTATION */.Yj.SEGMENTATION,
            seo_page_id: Number(seoPageMetadata.seoPageId),
            service_id_for_member: "".concat(activityDetails === null || activityDetails === void 0 ? void 0 : activityDetails.serviceIdForMember, "Activity"),
            slots: constants/* TealiumSlot.VISITOR */.vm.VISITOR
        };
        if (deviceChar && Object.keys(deviceChar).length > 0) {
            (0,analyticsHelper/* setPagePropertiesFromData */.UP)(pageProperties);
            (0,analyticsHelper/* setDeviceDataFromHeaders */.xF)(validateHeaderData(deviceChar));
        }
    }, [
        deviceChar,
        stringifyDeviceChar,
        seoPageMetadata.seoPageId,
        activityDetails.serviceIdForMember, 
    ]);
    (0,react.useEffect)(function() {
        var ref;
        (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoPageViewed */.Sj.seoPageViewed, {
            seo_page_type: "C&A SEO page",
            page_template: isNationalListPage ? "National" : "Local",
            seo_page_title: (ref = activityDetails === null || activityDetails === void 0 ? void 0 : activityDetails.headline) !== null && ref !== void 0 ? ref : "",
            service_id_for_member: "".concat(activityDetails === null || activityDetails === void 0 ? void 0 : activityDetails.serviceIdForMember, "Activity")
        });
    }, [
        local,
        isNationalListPage,
        activityDetails === null || activityDetails === void 0 ? void 0 : activityDetails.headline,
        activityDetails === null || activityDetails === void 0 ? void 0 : activityDetails.serviceIdForMember
    ]);
    (0,react.useEffect)(function() {
        if (location.zipcode || filters && Object.keys(filters).length >= 1) {
            var _zipcode, ref, ref1, ref2, ref3, ref4, ref5;
            (0,analyticsHelper/* trackAmplitudeEvent */.rG)(analyticsHelper/* AmplitudeEvent.seoFeatureInteracted */.Sj.seoFeatureInteracted, {
                feature_name: "Filters Applied",
                location: (_zipcode = location.zipcode) !== null && _zipcode !== void 0 ? _zipcode : "",
                ages: (ref = filters === null || filters === void 0 ? void 0 : filters[constants/* FilterFieldNames.ages */.d8.ages]) !== null && ref !== void 0 ? ref : [],
                days: (ref1 = filters === null || filters === void 0 ? void 0 : filters[constants/* FilterFieldNames.days */.d8.days]) !== null && ref1 !== void 0 ? ref1 : [],
                dates: (ref2 = filters === null || filters === void 0 ? void 0 : filters[constants/* FilterFieldNames.dates */.d8.dates]) !== null && ref2 !== void 0 ? ref2 : "",
                categories: (ref3 = filters === null || filters === void 0 ? void 0 : filters[constants/* FilterFieldNames.categories */.d8.categories]) !== null && ref3 !== void 0 ? ref3 : "",
                activity_type: (ref4 = filters === null || filters === void 0 ? void 0 : filters[constants/* FilterFieldNames.activityType */.d8.activityType]) !== null && ref4 !== void 0 ? ref4 : [],
                subcategories: (ref5 = filters === null || filters === void 0 ? void 0 : filters[constants/* FilterFieldNames.subcategories */.d8.subcategories]) !== null && ref5 !== void 0 ? ref5 : ""
            });
        }
    }, [
        filters,
        location.zipcode
    ]);
    (0,react.useEffect)(function() {
        (0,filtersStorage/* clearFilters */.K5)();
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(SegmentationFiltersContext/* SegmentationFiltersContext.Provider */.$I.Provider, {
        value: filtersCtx,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(FilterProvider/* FilterProvider */.h, {
            onChange: onFilterChange,
            "data-testid": "filter-provider",
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(GoogleMaps/* default.Provider */.Z.Provider, {
                requestOptions: {
                    types: locationTypes
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(PageMeta/* default */.Z, {
                        title: seoPageMetadata.title,
                        canonicalUrl: seoPageMetadata.canonicalURL,
                        metaDescriptions: seoPageMetadata.metaDescriptions,
                        metaKeywords: seoPageMetadata.metaKeywords,
                        paginationPageCount: initialPagination.numberOfPages,
                        paginationCurrentPage: pageNumber,
                        seoSegmentNamePlural: activityDetails.segmentNamePlural,
                        isCampsAndActivitiesPage: true
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(SeoGlobalNavbar/* SeoGlobalNavbar */.L, {
                        seoNavigationLinkSection: pageData.seoNavigationLinkSection
                    }),
                    showProviderSignUpBanner && /*#__PURE__*/ (0,jsx_runtime.jsx)(ProviderSignUpBanner_ProviderSignUpBanner, {}),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(ExploreFilters, {
                        activityCategory: activityDetails.category,
                        activitySubcategory: activityDetails.subcategory,
                        LocationInput: /*#__PURE__*/ (0,jsx_runtime.jsx)(shared_ExploreLocationSearch, {
                            address: location,
                            onChange: setLocation,
                            isLoading: isLoading
                        }),
                        isMobile: isSmallViewport
                    }),
                    isSmallViewport && /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitiesMapCTA, {
                        showMap: showMap,
                        setShowMap: setShowMap
                    }),
                    isSmallViewport && showMap ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                        container: true,
                        component: "main",
                        height: "100%",
                        width: "100%",
                        item: true,
                        xs: 12,
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitiesMap, {
                            activitiesSearchResults: activitySearchResults,
                            userGeoInfo: userGeoInfo,
                            location: location
                        })
                    }) : /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                maxWidth: "xl",
                                ref: scrollToTopRef,
                                sx: {
                                    px: 3
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                    container: true,
                                    component: "main",
                                    item: true,
                                    xs: 12,
                                    children: [
                                        /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.ZP, {
                                            item: true,
                                            xs: 12,
                                            sm: 9,
                                            md: 9,
                                            mt: 4,
                                            pr: 3,
                                            children: [
                                                !isSmallViewport && breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                                    item: true,
                                                    xs: 12,
                                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                                        breadcrumbs: breadcrumbs
                                                    })
                                                }),
                                                activityDetails.headline && /*#__PURE__*/ (0,jsx_runtime.jsx)(ExploreHeaderText, {
                                                    headline: activityDetails.headline,
                                                    hasResults: isLoading || !!activitySearchResults.length
                                                }),
                                                activitySearchResults.length ? /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitiesList, {
                                                    activityDetails: activityDetails,
                                                    isLoading: isLoading,
                                                    searchResult: activitySearchResults
                                                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)(campsAndActivities_ExploreNoResults, {
                                                    noResults: true,
                                                    isNationalListPage: isNationalListPage,
                                                    isMobileOrSmaller: isSmallViewport
                                                }),
                                                /*#__PURE__*/ (0,jsx_runtime.jsx)(Pagination/* default */.Z, {
                                                    onPageClick: handlePageClick,
                                                    pagination: pagination,
                                                    segmentId: seoSegmentId,
                                                    pageSelected: pageNumber
                                                })
                                            ]
                                        }),
                                        (isMediumViewport || isLargeViewport) && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                            item: true,
                                            sm: 3,
                                            md: 3,
                                            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ActivitiesMap, {
                                                activitiesSearchResults: activitySearchResults,
                                                userGeoInfo: userGeoInfo,
                                                location: location
                                            })
                                        })
                                    ]
                                })
                            }),
                            (articles === null || articles === void 0 ? void 0 : articles.articles) && /*#__PURE__*/ (0,jsx_runtime.jsx)(ArticleSection.ArticleSection, {
                                articles: articles.articles
                            }),
                            faqs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                maxWidth: "xl",
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                    sx: {
                                        py: {
                                            xs: 2,
                                            xl: 0
                                        },
                                        mx: {
                                            xl: 10
                                        }
                                    },
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_FAQs, {
                                        faqs: faqs
                                    })
                                })
                            }),
                            linkSections && /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                sx: {
                                    backgroundColor: "background.secondary"
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Container/* default */.Z, {
                                    maxWidth: "xl",
                                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
                                        sx: {
                                            mt: 3,
                                            "& .MuiContainer-root": {
                                                margin: "0 !important"
                                            },
                                            py: {
                                                xs: 6,
                                                sm: 10
                                            },
                                            mx: {
                                                sm: 10
                                            }
                                        },
                                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(components_SeoLinkList, {
                                            seoLinkList: linkSections,
                                            internalLinkingHeadline: internalLinkingHeadline,
                                            seoSegmentNamePlural: activityDetails.segmentNamePlural
                                        })
                                    })
                                })
                            }),
                            isSmallViewport && breadcrumbs && /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.ZP, {
                                item: true,
                                xs: 12,
                                sx: {
                                    pb: 6,
                                    pl: 2,
                                    pt: 2
                                },
                                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Breadcrumbs/* default */.Z, {
                                    breadcrumbs: breadcrumbs
                                })
                            }),
                            /*#__PURE__*/ (0,jsx_runtime.jsx)(CoreGlobalFooter/* default */.Z, {
                                variant: "inverse"
                            })
                        ]
                    })
                ]
            })
        })
    });
};
/* harmony default export */ var campsAndActivities_CampsAndActivitiesListingPage = (CampsAndActivitiesListingPage);
var getServerSideProps = function() {
    var _ref = (0,_async_to_generator/* default */.Z)(function(context) {
        return (0,tslib_es6.__generator)(this, function(_state) {
            return [
                2,
                campsAndActivitiesPageListingProps(context)
            ];
        });
    });
    return function getServerSideProps(context) {
        return _ref.apply(this, arguments);
    };
}();

;// CONCATENATED MODULE: ./src/components/pages/campsAndActivities/index.ts




/***/ }),

/***/ 42182:
/***/ (function(__unused_webpack_module, __webpack_exports__) {

"use strict";
/*
 * date conversion to one of the following example formats:
 * Apr 2023
 * April 2023
 * Apr 25, 2023
 * April 25, 2023
 * Apr 25th, 2023
 * April 25th, 2023
 */ // Add postfix like 3rd, 4th, 22nd to the date
var getOrdinalNum = function(n) {
    return n + (n > 0 ? [
        "th",
        "st",
        "nd",
        "rd"
    ][n > 3 && n < 21 || n % 10 > 3 ? 0 : n % 10] : "");
};
var dateMonthYearFormat = function(param) {
    var dateTime = param.dateTime, _useLongMonth = param.useLongMonth, useLongMonth = _useLongMonth === void 0 ? false : _useLongMonth, _useOrdinalDay = param.useOrdinalDay, useOrdinalDay = _useOrdinalDay === void 0 ? false : _useOrdinalDay, _useFullDate = param.useFullDate, useFullDate = _useFullDate === void 0 ? false : _useFullDate;
    var date = new Date(dateTime);
    var dayOftheMonth = useOrdinalDay ? "".concat(getOrdinalNum(date.getUTCDate())) : date.getUTCDate();
    var month = useLongMonth ? date.toLocaleString("en-US", {
        month: "long"
    }) : date.toLocaleString("en-US", {
        month: "short"
    });
    var year = date.getUTCFullYear();
    return useFullDate ? "".concat(month, " ").concat(dayOftheMonth, ", ").concat(year) : "".concat(month, " ").concat(year);
};
/* harmony default export */ __webpack_exports__["Z"] = (dateMonthYearFormat);


/***/ }),

/***/ 85627:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "HJ": function() { return /* binding */ saveFilters; },
/* harmony export */   "K5": function() { return /* binding */ clearFilters; },
/* harmony export */   "dm": function() { return /* binding */ loadFilters; },
/* harmony export */   "ku": function() { return /* binding */ removeFilter; }
/* harmony export */ });
/* unused harmony export updateFilterField */
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(26042);


var loadFilters = function() {
    try {
        var serializedState = localStorage.getItem("filters");
        if (serializedState === null) {
            return null;
        }
        return JSON.parse(serializedState);
    } catch (err) {
        return null;
    }
};
var saveFilters = function(filter, __callback) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        filterObj = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)({}, filterObj, filter);
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
        if (__callback) {
            __callback();
        }
    } catch (err) {
    // return undefined;
    }
};
var updateFilterField = function(filterName, filterValue) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        set(filterObj, filterName, filterValue);
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
    } catch (err) {
    // return undefined;
    }
};
var clearFilters = function() {
    try {
        localStorage.removeItem("filters");
    } catch (err) {
    // return undefined;
    }
};
var removeFilter = function(key) {
    try {
        var storedFilters = localStorage.getItem("filters");
        var filterObj = JSON.parse(storedFilters || "{}");
        delete filterObj[key];
        var serializedState = JSON.stringify(filterObj);
        localStorage.setItem("filters", serializedState);
    } catch (err) {
    // return undefined;
    }
};


/***/ }),

/***/ 93867:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(28906);

var getDeviceCharacteristics = function(userAgent, deviceCharHeader) {
    var deviceChar = (0,_reqHeaderToEntriesObj__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(deviceCharHeader, ";");
    if (Object.keys(deviceChar).length === 0) {
        if (/Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(userAgent)) {
            deviceChar = {
                is_mobile: "true"
            };
        } else {
            deviceChar = {
                is_mobile: "false"
            };
        }
    }
    return deviceChar;
};
/* harmony default export */ __webpack_exports__["Z"] = (getDeviceCharacteristics);


/***/ }),

/***/ 7360:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ getZipcodeFromGeoInfo; }
/* harmony export */ });
var getZipcodeFromGeoInfo = function(userGeoInfo) {
    var match = userGeoInfo === null || userGeoInfo === void 0 ? void 0 : userGeoInfo.match(/zip=(\d{5})/);
    if (match && match[1]) {
        return match[1];
    }
    return "";
};


/***/ }),

/***/ 28906:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(828);
/**
 * Transmutes a key/value pairs object into the format expected by GraphQLEnumType
 * @param  {string} header header string of keys and values
 * @param  {string} delimeter symbol used to separate each key value pair from the next pair
 * @param  {string} valueDelimeter symbol used to separate the key from its value within each pair
 * @return {Object}     Entries object (key/value pairs)
 */ 
var reqHeaderToEntriesObj = function(header) {
    var delimiter = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : ";", valueDelimeter = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : "=";
    if (header === "") return {};
    return header.split(delimiter).reduce(function(accum, curVal) {
        var obj = accum;
        var keyValuePair = curVal.split(valueDelimeter);
        var _keyValuePair = (0,_swc_helpers_src_sliced_to_array_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)(keyValuePair, 2), keyValuePairKey = _keyValuePair[0], keyValuePairValue = _keyValuePair[1];
        obj[keyValuePairKey] = keyValuePairValue;
        return obj;
    }, {});
};
/* harmony default export */ __webpack_exports__["Z"] = (reqHeaderToEntriesObj);


/***/ }),

/***/ 75347:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 31777:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 34017:
/***/ (function() {

/* (ignored) */

/***/ }),

/***/ 59905:
/***/ (function() {

/* (ignored) */

/***/ })

}]);